export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CvServiceCampaignTabDetailContentRowsDynamicZoneInput: { input: unknown; output: unknown; }
  Date: { input: unknown; output: unknown; }
  DateTime: { input: unknown; output: unknown; }
  JSON: { input: unknown; output: unknown; }
  LcvNewsDetailContentRowsDynamicZoneInput: { input: unknown; output: unknown; }
  LcvServiceCampaignTabDetailContentRowsDynamicZoneInput: { input: unknown; output: unknown; }
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentLineupLcvCategoryModelItems = {
  active?: Maybe<Scalars['Boolean']['output']>;
  defaultCompareModels: Array<Maybe<LcvModel>>;
  defaultCompareModels_connection?: Maybe<LcvModelRelationResponseCollection>;
  id: Scalars['ID']['output'];
  lineupModels?: Maybe<Array<Maybe<ComponentLineupLcvModelItem>>>;
  modelYear: Scalars['String']['output'];
};


export type ComponentLineupLcvCategoryModelItemsDefaultCompareModelsArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentLineupLcvCategoryModelItemsDefaultCompareModels_ConnectionArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentLineupLcvCategoryModelItemsLineupModelsArgs = {
  filters?: InputMaybe<ComponentLineupLcvModelItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLineupLcvCategoryModelItemsFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentLineupLcvCategoryModelItemsFiltersInput>>>;
  defaultCompareModels?: InputMaybe<LcvModelFiltersInput>;
  lineupModels?: InputMaybe<ComponentLineupLcvModelItemFiltersInput>;
  modelYear?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentLineupLcvCategoryModelItemsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLineupLcvCategoryModelItemsFiltersInput>>>;
};

export type ComponentLineupLcvCategoryModelItemsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  defaultCompareModels?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lineupModels?: InputMaybe<Array<InputMaybe<ComponentLineupLcvModelItemInput>>>;
  modelYear?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLineupLcvDefaultModelGradeByCategory = {
  defaultModel?: Maybe<LcvModel>;
  id: Scalars['ID']['output'];
  subCategory?: Maybe<Array<Maybe<ComponentLineupLcvDefaultModelGradeBySubCategory>>>;
};


export type ComponentLineupLcvDefaultModelGradeByCategorySubCategoryArgs = {
  filters?: InputMaybe<ComponentLineupLcvDefaultModelGradeBySubCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLineupLcvDefaultModelGradeByCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLineupLcvDefaultModelGradeByCategoryFiltersInput>>>;
  defaultModel?: InputMaybe<LcvModelFiltersInput>;
  not?: InputMaybe<ComponentLineupLcvDefaultModelGradeByCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLineupLcvDefaultModelGradeByCategoryFiltersInput>>>;
  subCategory?: InputMaybe<ComponentLineupLcvDefaultModelGradeBySubCategoryFiltersInput>;
};

export type ComponentLineupLcvDefaultModelGradeByCategoryInput = {
  defaultModel?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subCategory?: InputMaybe<Array<InputMaybe<ComponentLineupLcvDefaultModelGradeBySubCategoryInput>>>;
};

export type ComponentLineupLcvDefaultModelGradeBySubCategory = {
  defaultSubModel?: Maybe<LcvModel>;
  id: Scalars['ID']['output'];
  subCategory?: Maybe<LcvModelSubCategory>;
  subCategoryLabel?: Maybe<Scalars['String']['output']>;
};

export type ComponentLineupLcvDefaultModelGradeBySubCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLineupLcvDefaultModelGradeBySubCategoryFiltersInput>>>;
  defaultSubModel?: InputMaybe<LcvModelFiltersInput>;
  not?: InputMaybe<ComponentLineupLcvDefaultModelGradeBySubCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLineupLcvDefaultModelGradeBySubCategoryFiltersInput>>>;
  subCategory?: InputMaybe<LcvModelSubCategoryFiltersInput>;
  subCategoryLabel?: InputMaybe<StringFilterInput>;
};

export type ComponentLineupLcvDefaultModelGradeBySubCategoryInput = {
  defaultSubModel?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subCategory?: InputMaybe<Scalars['ID']['input']>;
  subCategoryLabel?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLineupLcvModelItem = {
  category?: Maybe<LcvModelCategory>;
  defaultModelGrade?: Maybe<ComponentLineupLcvDefaultModelGradeByCategory>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  models: Array<Maybe<LcvModel>>;
  models_connection?: Maybe<LcvModelRelationResponseCollection>;
};


export type ComponentLineupLcvModelItemModelsArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentLineupLcvModelItemModels_ConnectionArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLineupLcvModelItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLineupLcvModelItemFiltersInput>>>;
  category?: InputMaybe<LcvModelCategoryFiltersInput>;
  defaultModelGrade?: InputMaybe<ComponentLineupLcvDefaultModelGradeByCategoryFiltersInput>;
  label?: InputMaybe<StringFilterInput>;
  models?: InputMaybe<LcvModelFiltersInput>;
  not?: InputMaybe<ComponentLineupLcvModelItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLineupLcvModelItemFiltersInput>>>;
};

export type ComponentLineupLcvModelItemInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  defaultModelGrade?: InputMaybe<ComponentLineupLcvDefaultModelGradeByCategoryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  models?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ComponentMaintenancePartGroup = {
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  parts?: Maybe<Array<Maybe<ComponentMaintenancePartItem>>>;
  title: Scalars['String']['output'];
};


export type ComponentMaintenancePartGroupPartsArgs = {
  filters?: InputMaybe<ComponentMaintenancePartItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMaintenancePartGroupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMaintenancePartGroupFiltersInput>>>;
  key?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMaintenancePartGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMaintenancePartGroupFiltersInput>>>;
  parts?: InputMaybe<ComponentMaintenancePartItemFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentMaintenancePartGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<ComponentMaintenancePartItemInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMaintenancePartItem = {
  enable?: Maybe<Scalars['Boolean']['output']>;
  forceDisplayText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  showOnMain?: Maybe<Scalars['Boolean']['output']>;
  showOnSummary?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentMaintenancePartItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMaintenancePartItemFiltersInput>>>;
  enable?: InputMaybe<BooleanFilterInput>;
  forceDisplayText?: InputMaybe<StringFilterInput>;
  key?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMaintenancePartItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMaintenancePartItemFiltersInput>>>;
  showOnMain?: InputMaybe<BooleanFilterInput>;
  showOnSummary?: InputMaybe<BooleanFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentMaintenancePartItemInput = {
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  forceDisplayText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  showOnMain?: InputMaybe<Scalars['Boolean']['input']>;
  showOnSummary?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMaintenanceSchedule = {
  costBeforeVat?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountCoupon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maintenanceDescription?: Maybe<Scalars['String']['output']>;
  maintenancePrivileges?: Maybe<Array<Maybe<ComponentSharedTextItem>>>;
  mileage: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  partGroups?: Maybe<Array<Maybe<ComponentMaintenancePartGroup>>>;
  preventiveMaintenanceParts?: Maybe<Array<Maybe<ComponentSharedTextItem>>>;
  specialCostDescription?: Maybe<Scalars['String']['output']>;
  totalCostWithVat: Scalars['Float']['output'];
};


export type ComponentMaintenanceScheduleMaintenancePrivilegesArgs = {
  filters?: InputMaybe<ComponentSharedTextItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentMaintenanceSchedulePartGroupsArgs = {
  filters?: InputMaybe<ComponentMaintenancePartGroupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentMaintenanceSchedulePreventiveMaintenancePartsArgs = {
  filters?: InputMaybe<ComponentSharedTextItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMaintenanceScheduleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMaintenanceScheduleFiltersInput>>>;
  costBeforeVat?: InputMaybe<FloatFilterInput>;
  discountAmount?: InputMaybe<FloatFilterInput>;
  discountCoupon?: InputMaybe<StringFilterInput>;
  maintenanceDescription?: InputMaybe<StringFilterInput>;
  maintenancePrivileges?: InputMaybe<ComponentSharedTextItemFiltersInput>;
  mileage?: InputMaybe<IntFilterInput>;
  month?: InputMaybe<IntFilterInput>;
  not?: InputMaybe<ComponentMaintenanceScheduleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMaintenanceScheduleFiltersInput>>>;
  partGroups?: InputMaybe<ComponentMaintenancePartGroupFiltersInput>;
  preventiveMaintenanceParts?: InputMaybe<ComponentSharedTextItemFiltersInput>;
  specialCostDescription?: InputMaybe<StringFilterInput>;
  totalCostWithVat?: InputMaybe<FloatFilterInput>;
};

export type ComponentMaintenanceScheduleInput = {
  costBeforeVat?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  discountCoupon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  maintenanceDescription?: InputMaybe<Scalars['String']['input']>;
  maintenancePrivileges?: InputMaybe<Array<InputMaybe<ComponentSharedTextItemInput>>>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  partGroups?: InputMaybe<Array<InputMaybe<ComponentMaintenancePartGroupInput>>>;
  preventiveMaintenanceParts?: InputMaybe<Array<InputMaybe<ComponentSharedTextItemInput>>>;
  specialCostDescription?: InputMaybe<Scalars['String']['input']>;
  totalCostWithVat?: InputMaybe<Scalars['Float']['input']>;
};

export type ComponentMaintenanceVehicleModel = {
  id: Scalars['ID']['output'];
  modelCode: Scalars['String']['output'];
  optionCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentMaintenanceVehicleModelFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMaintenanceVehicleModelFiltersInput>>>;
  modelCode?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentMaintenanceVehicleModelFiltersInput>;
  optionCode?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMaintenanceVehicleModelFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentMaintenanceVehicleModelInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  modelCode?: InputMaybe<Scalars['String']['input']>;
  optionCode?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNewsHeader = {
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type ComponentNewsHighlighted = {
  id: Scalars['ID']['output'];
  textContent: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ComponentNewsImages = {
  id: Scalars['ID']['output'];
  imageDisplay: Enum_Componentnewsimages_Imagedisplay;
  images: Array<Maybe<UploadFile>>;
  images_connection: UploadFileRelationResponseCollection;
};


export type ComponentNewsImagesImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentNewsImagesImages_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentNewsNewsDetailRow = {
  detailDescription?: Maybe<Scalars['String']['output']>;
  detailImage: Array<Maybe<UploadFile>>;
  detailImageLayout?: Maybe<Enum_Componentnewsnewsdetailrow_Detailimagelayout>;
  detailImageOrientation?: Maybe<Enum_Componentnewsnewsdetailrow_Detailimageorientation>;
  detailImage_connection?: Maybe<UploadFileRelationResponseCollection>;
  detailTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  showDetailRowDivider?: Maybe<Scalars['Boolean']['output']>;
};


export type ComponentNewsNewsDetailRowDetailImageArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentNewsNewsDetailRowDetailImage_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentNewsNewsPinnedByCategory = {
  category?: Maybe<LcvNewsCategory>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  pinnedNews?: Maybe<LcvNewsDetail>;
};

export type ComponentNewsNewsPinnedByCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNewsNewsPinnedByCategoryFiltersInput>>>;
  category?: InputMaybe<LcvNewsCategoryFiltersInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentNewsNewsPinnedByCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNewsNewsPinnedByCategoryFiltersInput>>>;
  pinnedNews?: InputMaybe<LcvNewsDetailFiltersInput>;
};

export type ComponentNewsNewsPinnedByCategoryInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  pinnedNews?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentNewsSingleImage = {
  id: Scalars['ID']['output'];
  image: UploadFile;
};

export type ComponentNewsTextContent = {
  id: Scalars['ID']['output'];
  textContent: Scalars['String']['output'];
};

export type ComponentNewsTextContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNewsTextContentFiltersInput>>>;
  not?: InputMaybe<ComponentNewsTextContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNewsTextContentFiltersInput>>>;
  textContent?: InputMaybe<StringFilterInput>;
};

export type ComponentNewsTextContentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  textContent?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNewsYoutube = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  youtubeId: Scalars['String']['output'];
};

export type ComponentOmoCvOmoCategoryModelLineup = {
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  modelClasses: Array<Maybe<CvModelClass>>;
  modelClasses_connection?: Maybe<CvModelClassRelationResponseCollection>;
  subCategory?: Maybe<CvModelSubCategory>;
};


export type ComponentOmoCvOmoCategoryModelLineupModelClassesArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentOmoCvOmoCategoryModelLineupModelClasses_ConnectionArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentOmoCvOmoCategoryModelLineupFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentOmoCvOmoCategoryModelLineupFiltersInput>>>;
  label?: InputMaybe<StringFilterInput>;
  modelClasses?: InputMaybe<CvModelClassFiltersInput>;
  not?: InputMaybe<ComponentOmoCvOmoCategoryModelLineupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentOmoCvOmoCategoryModelLineupFiltersInput>>>;
  subCategory?: InputMaybe<CvModelSubCategoryFiltersInput>;
};

export type ComponentOmoCvOmoCategoryModelLineupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelClasses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subCategory?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentOmoCvOmoEngineLineup = {
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  modelClasses: Array<Maybe<CvModelClass>>;
  modelClasses_connection?: Maybe<CvModelClassRelationResponseCollection>;
};


export type ComponentOmoCvOmoEngineLineupModelClassesArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentOmoCvOmoEngineLineupModelClasses_ConnectionArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentOmoLcvOmoModelCategoryLineup = {
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  modelCategory?: Maybe<LcvModelCategory>;
  models: Array<Maybe<LcvModel>>;
  models_connection?: Maybe<LcvModelRelationResponseCollection>;
};


export type ComponentOmoLcvOmoModelCategoryLineupModelsArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentOmoLcvOmoModelCategoryLineupModels_ConnectionArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentOmoLcvOmoModelCategoryLineupFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentOmoLcvOmoModelCategoryLineupFiltersInput>>>;
  label?: InputMaybe<StringFilterInput>;
  modelCategory?: InputMaybe<LcvModelCategoryFiltersInput>;
  models?: InputMaybe<LcvModelFiltersInput>;
  not?: InputMaybe<ComponentOmoLcvOmoModelCategoryLineupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentOmoLcvOmoModelCategoryLineupFiltersInput>>>;
};

export type ComponentOmoLcvOmoModelCategoryLineupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelCategory?: InputMaybe<Scalars['ID']['input']>;
  models?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ComponentOmoLcvOmoYearLineup = {
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  modelYear: Scalars['String']['output'];
  models: Array<Maybe<LcvModel>>;
  models_connection?: Maybe<LcvModelRelationResponseCollection>;
};


export type ComponentOmoLcvOmoYearLineupModelsArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentOmoLcvOmoYearLineupModels_ConnectionArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentServicesGenuinePart = {
  genuinePartType?: Maybe<Enum_Componentservicesgenuinepart_Genuineparttype>;
  id: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  showStartPricePrefix?: Maybe<Scalars['Boolean']['output']>;
  showTitle?: Maybe<Scalars['Boolean']['output']>;
  specialPrice?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type ComponentServicesGenuinePartFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentServicesGenuinePartFiltersInput>>>;
  genuinePartType?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentServicesGenuinePartFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentServicesGenuinePartFiltersInput>>>;
  price?: InputMaybe<IntFilterInput>;
  showStartPricePrefix?: InputMaybe<BooleanFilterInput>;
  showTitle?: InputMaybe<BooleanFilterInput>;
  specialPrice?: InputMaybe<IntFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  unit?: InputMaybe<StringFilterInput>;
};

export type ComponentServicesGenuinePartInput = {
  genuinePartType?: InputMaybe<Enum_Componentservicesgenuinepart_Genuineparttype>;
  id?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  showStartPricePrefix?: InputMaybe<Scalars['Boolean']['input']>;
  showTitle?: InputMaybe<Scalars['Boolean']['input']>;
  specialPrice?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentServicesPartCategoryItem = {
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  partCategory?: Maybe<PartCategory>;
  partItems: Array<Maybe<PartItem>>;
  partItems_connection?: Maybe<PartItemRelationResponseCollection>;
};


export type ComponentServicesPartCategoryItemPartItemsArgs = {
  filters?: InputMaybe<PartItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentServicesPartCategoryItemPartItems_ConnectionArgs = {
  filters?: InputMaybe<PartItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentServicesPartCategoryItemFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentServicesPartCategoryItemFiltersInput>>>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentServicesPartCategoryItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentServicesPartCategoryItemFiltersInput>>>;
  partCategory?: InputMaybe<PartCategoryFiltersInput>;
  partItems?: InputMaybe<PartItemFiltersInput>;
};

export type ComponentServicesPartCategoryItemInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  partCategory?: InputMaybe<Scalars['ID']['input']>;
  partItems?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ComponentServicesServiceHomeItem = {
  id: Scalars['ID']['output'];
  image: UploadFile;
  otherLink?: Maybe<ComponentSharedButton>;
  youtubeUrl?: Maybe<Scalars['String']['output']>;
};

export type ComponentServicesServiceHomeItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentServicesServiceHomeItemFiltersInput>>>;
  not?: InputMaybe<ComponentServicesServiceHomeItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentServicesServiceHomeItemFiltersInput>>>;
  otherLink?: InputMaybe<ComponentSharedButtonFiltersInput>;
  youtubeUrl?: InputMaybe<StringFilterInput>;
};

export type ComponentServicesServiceHomeItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  otherLink?: InputMaybe<ComponentSharedButtonInput>;
  youtubeUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedButton = {
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  target?: Maybe<Enum_Componentsharedbutton_Target>;
  url: Scalars['String']['output'];
};

export type ComponentSharedButtonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedButtonFiltersInput>>>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedButtonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedButtonFiltersInput>>>;
  target?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedButtonInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Enum_Componentsharedbutton_Target>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedButtonWithIcons = {
  icon?: Maybe<Enum_Componentsharedbuttonwithicons_Icon>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Enum_Componentsharedbuttonwithicons_Target>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedButtonWithIconsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedButtonWithIconsFiltersInput>>>;
  icon?: InputMaybe<StringFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedButtonWithIconsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedButtonWithIconsFiltersInput>>>;
  target?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedButtonWithIconsInput = {
  icon?: InputMaybe<Enum_Componentsharedbuttonwithicons_Icon>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Enum_Componentsharedbuttonwithicons_Target>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedComponentAccordion = {
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentSharedComponentAccordionItem>>;
};


export type ComponentSharedComponentAccordionItemsArgs = {
  filters?: InputMaybe<ComponentSharedComponentAccordionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentAccordionItem = {
  description?: Maybe<Array<Maybe<ComponentSharedComponentDescription>>>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};


export type ComponentSharedComponentAccordionItemDescriptionArgs = {
  filters?: InputMaybe<ComponentSharedComponentDescriptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentAccordionItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentAccordionItemFiltersInput>>>;
  description?: InputMaybe<ComponentSharedComponentDescriptionFiltersInput>;
  not?: InputMaybe<ComponentSharedComponentAccordionItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentAccordionItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedComponentDescription = {
  id: Scalars['ID']['output'];
  size: Enum_Componentsharedcomponentdescription_Size;
  textContent?: Maybe<Scalars['String']['output']>;
  textStyle: Enum_Componentsharedcomponentdescription_Textstyle;
};

export type ComponentSharedComponentDescriptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentDescriptionFiltersInput>>>;
  not?: InputMaybe<ComponentSharedComponentDescriptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentDescriptionFiltersInput>>>;
  size?: InputMaybe<StringFilterInput>;
  textContent?: InputMaybe<StringFilterInput>;
  textStyle?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedComponentHeader = {
  id: Scalars['ID']['output'];
  size: Enum_Componentsharedcomponentheader_Size;
  text?: Maybe<Scalars['String']['output']>;
  textStyle: Enum_Componentsharedcomponentheader_Textstyle;
};

export type ComponentSharedComponentHeaderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentHeaderFiltersInput>>>;
  not?: InputMaybe<ComponentSharedComponentHeaderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentHeaderFiltersInput>>>;
  size?: InputMaybe<StringFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  textStyle?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedComponentHighlightCard = {
  description?: Maybe<Array<Maybe<ComponentSharedComponentDescription>>>;
  id: Scalars['ID']['output'];
  image: UploadFile;
  textAlignment: Enum_Componentsharedcomponenthighlightcard_Textalignment;
};


export type ComponentSharedComponentHighlightCardDescriptionArgs = {
  filters?: InputMaybe<ComponentSharedComponentDescriptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentHighlightCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentHighlightCardFiltersInput>>>;
  description?: InputMaybe<ComponentSharedComponentDescriptionFiltersInput>;
  not?: InputMaybe<ComponentSharedComponentHighlightCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentHighlightCardFiltersInput>>>;
  textAlignment?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedComponentHighlightCardGroup = {
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentSharedComponentHighlightCard>>>;
};


export type ComponentSharedComponentHighlightCardGroupItemsArgs = {
  filters?: InputMaybe<ComponentSharedComponentHighlightCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentHtmlTable = {
  dataAlignment: Enum_Componentsharedcomponenthtmltable_Dataalignment;
  displayType: Enum_Componentsharedcomponenthtmltable_Displaytype;
  firstColumnTextStyle: Enum_Componentsharedcomponenthtmltable_Firstcolumntextstyle;
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentSharedComponentImageCard = {
  button?: Maybe<ComponentSharedButton>;
  description?: Maybe<ComponentSharedComponentDescription>;
  id: Scalars['ID']['output'];
  image: UploadFile;
  title?: Maybe<ComponentSharedComponentHeader>;
};

export type ComponentSharedComponentImageCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentImageCardFiltersInput>>>;
  button?: InputMaybe<ComponentSharedButtonFiltersInput>;
  description?: InputMaybe<ComponentSharedComponentDescriptionFiltersInput>;
  not?: InputMaybe<ComponentSharedComponentImageCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentImageCardFiltersInput>>>;
  title?: InputMaybe<ComponentSharedComponentHeaderFiltersInput>;
};

export type ComponentSharedComponentImageCardHorizontal = {
  id: Scalars['ID']['output'];
  item: ComponentSharedComponentImageCard;
  size: Enum_Componentsharedcomponentimagecardhorizontal_Size;
};

export type ComponentSharedComponentImageCardVertical = {
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentSharedComponentImageCard>>;
};


export type ComponentSharedComponentImageCardVerticalItemsArgs = {
  filters?: InputMaybe<ComponentSharedComponentImageCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentImageWithCta = {
  button?: Maybe<ComponentSharedButton>;
  id: Scalars['ID']['output'];
  image: UploadFile;
};

export type ComponentSharedComponentMyMemberTable = {
  bodyRows: Array<Maybe<ComponentSharedComponentMyMemberTableBodyRow>>;
  headerTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tableNameCMS: Scalars['String']['output'];
};


export type ComponentSharedComponentMyMemberTableBodyRowsArgs = {
  filters?: InputMaybe<ComponentSharedComponentMyMemberTableBodyRowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentMyMemberTableBodyRow = {
  diamond: ComponentSharedComponentMyMemberTableRank;
  gold: ComponentSharedComponentMyMemberTableRank;
  id: Scalars['ID']['output'];
  platinum: ComponentSharedComponentMyMemberTableRank;
  silver: ComponentSharedComponentMyMemberTableRank;
  title: Scalars['String']['output'];
  titleStyle: Enum_Componentsharedcomponentmymembertablebodyrow_Titlestyle;
};

export type ComponentSharedComponentMyMemberTableBodyRowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentMyMemberTableBodyRowFiltersInput>>>;
  diamond?: InputMaybe<ComponentSharedComponentMyMemberTableRankFiltersInput>;
  gold?: InputMaybe<ComponentSharedComponentMyMemberTableRankFiltersInput>;
  not?: InputMaybe<ComponentSharedComponentMyMemberTableBodyRowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentMyMemberTableBodyRowFiltersInput>>>;
  platinum?: InputMaybe<ComponentSharedComponentMyMemberTableRankFiltersInput>;
  silver?: InputMaybe<ComponentSharedComponentMyMemberTableRankFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  titleStyle?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedComponentMyMemberTableRank = {
  id: Scalars['ID']['output'];
  linkText: Scalars['String']['output'];
  linkUrl: Scalars['String']['output'];
  statusIcon: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  textStyle: Enum_Componentsharedcomponentmymembertablerank_Textstyle;
  type: Enum_Componentsharedcomponentmymembertablerank_Type;
};

export type ComponentSharedComponentMyMemberTableRankFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentMyMemberTableRankFiltersInput>>>;
  linkText?: InputMaybe<StringFilterInput>;
  linkUrl?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedComponentMyMemberTableRankFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentMyMemberTableRankFiltersInput>>>;
  statusIcon?: InputMaybe<BooleanFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  textStyle?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedComponentResponsiveTable = {
  bodyRows: Array<Maybe<ComponentSharedComponentResponsiveTableBodyRow>>;
  headerRow: Array<Maybe<ComponentSharedComponentResponsiveTableHeaderCell>>;
  id: Scalars['ID']['output'];
  showSubHeader?: Maybe<Scalars['Boolean']['output']>;
  subHeaderRow: Array<Maybe<ComponentSharedComponentResponsiveTableHeaderCell>>;
  theme: Enum_Componentsharedcomponentresponsivetable_Theme;
};


export type ComponentSharedComponentResponsiveTableBodyRowsArgs = {
  filters?: InputMaybe<ComponentSharedComponentResponsiveTableBodyRowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSharedComponentResponsiveTableHeaderRowArgs = {
  filters?: InputMaybe<ComponentSharedComponentResponsiveTableHeaderCellFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSharedComponentResponsiveTableSubHeaderRowArgs = {
  filters?: InputMaybe<ComponentSharedComponentResponsiveTableHeaderCellFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentResponsiveTableBodyColumn = {
  id: Scalars['ID']['output'];
  simpleText: ComponentSharedComponentResponsiveTableBodyColumnSimpleText;
  statusGroup: ComponentSharedComponentResponsiveTableBodyColumnStatusGroup;
  textarea: Scalars['String']['output'];
  textareaAlignment: Enum_Componentsharedcomponentresponsivetablebodycolumn_Textareaalignment;
  type: Enum_Componentsharedcomponentresponsivetablebodycolumn_Type;
};

export type ComponentSharedComponentResponsiveTableBodyColumnFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnFiltersInput>>>;
  not?: InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnFiltersInput>>>;
  simpleText?: InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnSimpleTextFiltersInput>;
  statusGroup?: InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnStatusGroupFiltersInput>;
  textarea?: InputMaybe<StringFilterInput>;
  textareaAlignment?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedComponentResponsiveTableBodyColumnSimpleText = {
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  textAlignment: Enum_Componentsharedcomponentresponsivetablebodycolumnsimpletext_Textalignment;
  textStyle: Enum_Componentsharedcomponentresponsivetablebodycolumnsimpletext_Textstyle;
};

export type ComponentSharedComponentResponsiveTableBodyColumnSimpleTextFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnSimpleTextFiltersInput>>>;
  not?: InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnSimpleTextFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnSimpleTextFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  textAlignment?: InputMaybe<StringFilterInput>;
  textStyle?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedComponentResponsiveTableBodyColumnStatusGroup = {
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  textStyle: Enum_Componentsharedcomponentresponsivetablebodycolumnstatusgroup_Textstyle;
  value: Scalars['Boolean']['output'];
  withText: Scalars['Boolean']['output'];
};

export type ComponentSharedComponentResponsiveTableBodyColumnStatusGroupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnStatusGroupFiltersInput>>>;
  not?: InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnStatusGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnStatusGroupFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  textStyle?: InputMaybe<StringFilterInput>;
  value?: InputMaybe<BooleanFilterInput>;
  withText?: InputMaybe<BooleanFilterInput>;
};

export type ComponentSharedComponentResponsiveTableBodyRow = {
  columns: Array<Maybe<ComponentSharedComponentResponsiveTableBodyColumn>>;
  id: Scalars['ID']['output'];
};


export type ComponentSharedComponentResponsiveTableBodyRowColumnsArgs = {
  filters?: InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentResponsiveTableBodyRowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentResponsiveTableBodyRowFiltersInput>>>;
  columns?: InputMaybe<ComponentSharedComponentResponsiveTableBodyColumnFiltersInput>;
  not?: InputMaybe<ComponentSharedComponentResponsiveTableBodyRowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentResponsiveTableBodyRowFiltersInput>>>;
};

export type ComponentSharedComponentResponsiveTableHeaderCell = {
  id: Scalars['ID']['output'];
  subTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentSharedComponentResponsiveTableHeaderCellFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentResponsiveTableHeaderCellFiltersInput>>>;
  not?: InputMaybe<ComponentSharedComponentResponsiveTableHeaderCellFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentResponsiveTableHeaderCellFiltersInput>>>;
  subTitle?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedComponentTextCard = {
  description?: Maybe<Array<Maybe<ComponentSharedComponentDescription>>>;
  id: Scalars['ID']['output'];
  theme: Enum_Componentsharedcomponenttextcard_Theme;
  title?: Maybe<ComponentSharedComponentHeader>;
};


export type ComponentSharedComponentTextCardDescriptionArgs = {
  filters?: InputMaybe<ComponentSharedComponentDescriptionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentTextCardFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentTextCardFiltersInput>>>;
  description?: InputMaybe<ComponentSharedComponentDescriptionFiltersInput>;
  not?: InputMaybe<ComponentSharedComponentTextCardFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentTextCardFiltersInput>>>;
  theme?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<ComponentSharedComponentHeaderFiltersInput>;
};

export type ComponentSharedComponentTextCardGroup = {
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ComponentSharedComponentTextCard>>>;
};


export type ComponentSharedComponentTextCardGroupItemsArgs = {
  filters?: InputMaybe<ComponentSharedComponentTextCardFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentTwoColumnsTable = {
  bodyRows: Array<Maybe<ComponentSharedComponentTwoColumnsTableBodyRow>>;
  header: ComponentSharedComponentTwoColumnsTableHeader;
  id: Scalars['ID']['output'];
};


export type ComponentSharedComponentTwoColumnsTableBodyRowsArgs = {
  filters?: InputMaybe<ComponentSharedComponentTwoColumnsTableBodyRowFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSharedComponentTwoColumnsTableBodyRow = {
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentSharedComponentTwoColumnsTableBodyRowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedComponentTwoColumnsTableBodyRowFiltersInput>>>;
  data?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSharedComponentTwoColumnsTableBodyRowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedComponentTwoColumnsTableBodyRowFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedComponentTwoColumnsTableHeader = {
  firstColumn: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  secondColumn: Scalars['String']['output'];
};

export type ComponentSharedComponentYoutube = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  youtubeId: Scalars['String']['output'];
};

export type ComponentSharedCvOfferOrder = {
  id: Scalars['ID']['output'];
  offer?: Maybe<CvOffer>;
};

export type ComponentSharedCvOfferOrderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedCvOfferOrderFiltersInput>>>;
  not?: InputMaybe<ComponentSharedCvOfferOrderFiltersInput>;
  offer?: InputMaybe<CvOfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedCvOfferOrderFiltersInput>>>;
};

export type ComponentSharedCvOfferOrderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  offer?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedDealerSearch = {
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedEngineType = {
  id: Scalars['ID']['output'];
  type?: Maybe<Enum_Componentsharedenginetype_Type>;
};

export type ComponentSharedEngineTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedEngineTypeFiltersInput>>>;
  not?: InputMaybe<ComponentSharedEngineTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedEngineTypeFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedEngineTypeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Enum_Componentsharedenginetype_Type>;
};

export type ComponentSharedLcvOfferOrder = {
  id: Scalars['ID']['output'];
  offer?: Maybe<LcvOffer>;
};

export type ComponentSharedLcvOfferOrderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedLcvOfferOrderFiltersInput>>>;
  not?: InputMaybe<ComponentSharedLcvOfferOrderFiltersInput>;
  offer?: InputMaybe<LcvOfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedLcvOfferOrderFiltersInput>>>;
};

export type ComponentSharedLcvOfferOrderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  offer?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentSharedMeta = {
  hideFromSearchEngines: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ogDescription: Scalars['String']['output'];
  ogImage?: Maybe<UploadFile>;
  ogTitle: Scalars['String']['output'];
};

export type ComponentSharedMetaFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedMetaFiltersInput>>>;
  hideFromSearchEngines?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentSharedMetaFiltersInput>;
  ogDescription?: InputMaybe<StringFilterInput>;
  ogTitle?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedMetaFiltersInput>>>;
};

export type ComponentSharedMetaInput = {
  hideFromSearchEngines?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['ID']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedModelGroup = {
  id: Scalars['ID']['output'];
  type?: Maybe<Enum_Componentsharedmodelgroup_Type>;
};

export type ComponentSharedModelGroupFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedModelGroupFiltersInput>>>;
  not?: InputMaybe<ComponentSharedModelGroupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedModelGroupFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedModelGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Enum_Componentsharedmodelgroup_Type>;
};

export type ComponentSharedSeo = {
  id: Scalars['ID']['output'];
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<UploadFile>;
  ogTitle?: Maybe<Scalars['String']['output']>;
};

export type ComponentSharedSeoFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
  not?: InputMaybe<ComponentSharedSeoFiltersInput>;
  ogDescription?: InputMaybe<StringFilterInput>;
  ogTitle?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedSeoFiltersInput>>>;
};

export type ComponentSharedSeoInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ogDescription?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['ID']['input']>;
  ogTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedTextItem = {
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type ComponentSharedTextItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSharedTextItemFiltersInput>>>;
  not?: InputMaybe<ComponentSharedTextItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSharedTextItemFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
};

export type ComponentSharedTextItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSharedVehicleType = {
  id: Scalars['ID']['output'];
  type?: Maybe<Enum_Componentsharedvehicletype_Type>;
};

export type ComponentSharedVehicleTypeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Enum_Componentsharedvehicletype_Type>;
};

export type ComponentSplashSplashPopup = {
  active: Scalars['Boolean']['output'];
  beginDate: Scalars['DateTime']['output'];
  ctaButton: ComponentSharedButton;
  endDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageDesktop: UploadFile;
  imageMobile: UploadFile;
  showCta?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

export type ComponentSplashSplashPopupFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSplashSplashPopupFiltersInput>>>;
  beginDate?: InputMaybe<DateTimeFilterInput>;
  ctaButton?: InputMaybe<ComponentSharedButtonFiltersInput>;
  endDate?: InputMaybe<DateTimeFilterInput>;
  not?: InputMaybe<ComponentSplashSplashPopupFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSplashSplashPopupFiltersInput>>>;
  showCta?: InputMaybe<BooleanFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentSplashSplashPopupInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  beginDate?: InputMaybe<Scalars['DateTime']['input']>;
  ctaButton?: InputMaybe<ComponentSharedButtonInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageDesktop?: InputMaybe<Scalars['ID']['input']>;
  imageMobile?: InputMaybe<Scalars['ID']['input']>;
  showCta?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSurveyScaleLabel = {
  displayEn?: Maybe<Scalars['String']['output']>;
  displayTh: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ComponentSurveyScaleLabelFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSurveyScaleLabelFiltersInput>>>;
  displayEn?: InputMaybe<StringFilterInput>;
  displayTh?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentSurveyScaleLabelFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSurveyScaleLabelFiltersInput>>>;
  value?: InputMaybe<StringFilterInput>;
};

export type ComponentSurveyScaleLabelInput = {
  displayEn?: InputMaybe<Scalars['String']['input']>;
  displayTh?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSurveySurveyItem = {
  conditionalScore?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isRequire?: Maybe<Scalars['Boolean']['output']>;
  isSubRequire?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  mainQuestion?: Maybe<QuestionItem>;
  subQuestionItems: Array<Maybe<QuestionItem>>;
  subQuestionItems_connection?: Maybe<QuestionItemRelationResponseCollection>;
  subTitleEn?: Maybe<Scalars['String']['output']>;
  subTitleTh?: Maybe<Scalars['String']['output']>;
};


export type ComponentSurveySurveyItemSubQuestionItemsArgs = {
  filters?: InputMaybe<QuestionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentSurveySurveyItemSubQuestionItems_ConnectionArgs = {
  filters?: InputMaybe<QuestionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSurveySurveyItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentSurveySurveyItemFiltersInput>>>;
  conditionalScore?: InputMaybe<IntFilterInput>;
  isRequire?: InputMaybe<BooleanFilterInput>;
  isSubRequire?: InputMaybe<BooleanFilterInput>;
  label?: InputMaybe<StringFilterInput>;
  mainQuestion?: InputMaybe<QuestionItemFiltersInput>;
  not?: InputMaybe<ComponentSurveySurveyItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSurveySurveyItemFiltersInput>>>;
  subQuestionItems?: InputMaybe<QuestionItemFiltersInput>;
  subTitleEn?: InputMaybe<StringFilterInput>;
  subTitleTh?: InputMaybe<StringFilterInput>;
};

export type ComponentSurveySurveyItemInput = {
  conditionalScore?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isRequire?: InputMaybe<Scalars['Boolean']['input']>;
  isSubRequire?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  mainQuestion?: InputMaybe<Scalars['ID']['input']>;
  subQuestionItems?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  subTitleEn?: InputMaybe<Scalars['String']['input']>;
  subTitleTh?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentSurveySurveyVersion = {
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  questionItems?: Maybe<Array<Maybe<ComponentSurveySurveyItem>>>;
  version: Scalars['String']['output'];
};


export type ComponentSurveySurveyVersionQuestionItemsArgs = {
  filters?: InputMaybe<ComponentSurveySurveyItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentSurveySurveyVersionFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentSurveySurveyVersionFiltersInput>>>;
  not?: InputMaybe<ComponentSurveySurveyVersionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentSurveySurveyVersionFiltersInput>>>;
  questionItems?: InputMaybe<ComponentSurveySurveyItemFiltersInput>;
  version?: InputMaybe<StringFilterInput>;
};

export type ComponentSurveySurveyVersionInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  questionItems?: InputMaybe<Array<InputMaybe<ComponentSurveySurveyItemInput>>>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentTruckTruckCategoryItems = {
  category?: Maybe<CvModelSubCategory>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  modelClasses: Array<Maybe<CvModelClass>>;
  modelClasses_connection?: Maybe<CvModelClassRelationResponseCollection>;
};


export type ComponentTruckTruckCategoryItemsModelClassesArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentTruckTruckCategoryItemsModelClasses_ConnectionArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentTruckTruckCategoryItemsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentTruckTruckCategoryItemsFiltersInput>>>;
  category?: InputMaybe<CvModelSubCategoryFiltersInput>;
  label?: InputMaybe<StringFilterInput>;
  modelClasses?: InputMaybe<CvModelClassFiltersInput>;
  not?: InputMaybe<ComponentTruckTruckCategoryItemsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentTruckTruckCategoryItemsFiltersInput>>>;
};

export type ComponentTruckTruckCategoryItemsInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  modelClasses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CvBodyType = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cv_model_classes: Array<Maybe<CvModelClass>>;
  cv_model_classes_connection?: Maybe<CvModelClassRelationResponseCollection>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CvBodyTypeCv_Model_ClassesArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvBodyTypeCv_Model_Classes_ConnectionArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvBodyTypeEntityResponseCollection = {
  nodes: Array<CvBodyType>;
  pageInfo: Pagination;
};

export type CvBodyTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvBodyTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  cv_model_classes?: InputMaybe<CvModelClassFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvBodyTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvBodyTypeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CvBodyTypeInput = {
  cv_model_classes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type CvBodyTypeRelationResponseCollection = {
  nodes: Array<CvBodyType>;
};

export type CvBusinessType = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cv_model_classes: Array<Maybe<CvModelClass>>;
  cv_model_classes_connection?: Maybe<CvModelClassRelationResponseCollection>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CvBusinessTypeCv_Model_ClassesArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvBusinessTypeCv_Model_Classes_ConnectionArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvBusinessTypeEntityResponseCollection = {
  nodes: Array<CvBusinessType>;
  pageInfo: Pagination;
};

export type CvBusinessTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvBusinessTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  cv_model_classes?: InputMaybe<CvModelClassFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvBusinessTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvBusinessTypeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CvBusinessTypeInput = {
  cv_model_classes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type CvBusinessTypeRelationResponseCollection = {
  nodes: Array<CvBusinessType>;
};

export type CvContentHubCategory = {
  contents: Array<Maybe<CvContentHubContent>>;
  contents_connection?: Maybe<CvContentHubContentRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  headlineDescription: Scalars['String']['output'];
  headlineTitle: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  meta?: Maybe<ComponentSharedSeo>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type CvContentHubCategoryContentsArgs = {
  filters?: InputMaybe<CvContentHubContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvContentHubCategoryContents_ConnectionArgs = {
  filters?: InputMaybe<CvContentHubContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvContentHubCategoryEntityResponseCollection = {
  nodes: Array<CvContentHubCategory>;
  pageInfo: Pagination;
};

export type CvContentHubCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvContentHubCategoryFiltersInput>>>;
  contents?: InputMaybe<CvContentHubContentFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  headlineDescription?: InputMaybe<StringFilterInput>;
  headlineTitle?: InputMaybe<StringFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  meta?: InputMaybe<ComponentSharedSeoFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvContentHubCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvContentHubCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type CvContentHubCategoryInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  headlineDescription?: InputMaybe<Scalars['String']['input']>;
  headlineTitle?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<ComponentSharedSeoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CvContentHubCategoryRelationResponseCollection = {
  nodes: Array<CvContentHubCategory>;
};

export type CvContentHubConfig = {
  categoryOrder: Array<Maybe<CvContentHubCategory>>;
  categoryOrder_connection?: Maybe<CvContentHubCategoryRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  enabled: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  tagOrder: Array<Maybe<CvContentHubTag>>;
  tagOrder_connection?: Maybe<CvContentHubTagRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CvContentHubConfigCategoryOrderArgs = {
  filters?: InputMaybe<CvContentHubCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvContentHubConfigCategoryOrder_ConnectionArgs = {
  filters?: InputMaybe<CvContentHubCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvContentHubConfigTagOrderArgs = {
  filters?: InputMaybe<CvContentHubTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvContentHubConfigTagOrder_ConnectionArgs = {
  filters?: InputMaybe<CvContentHubTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvContentHubConfigInput = {
  categoryOrder?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  tagOrder?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CvContentHubContent = {
  author?: Maybe<Scalars['String']['output']>;
  beginDate: Scalars['Date']['output'];
  category: CvContentHubCategory;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  detailImage: UploadFile;
  documentId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  meta?: Maybe<ComponentSharedSeo>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  tags: Array<Maybe<CvContentHubTag>>;
  tags_connection: CvContentHubTagRelationResponseCollection;
  thumbnailImage: UploadFile;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  youtubeId?: Maybe<Scalars['String']['output']>;
};


export type CvContentHubContentTagsArgs = {
  filters?: InputMaybe<CvContentHubTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvContentHubContentTags_ConnectionArgs = {
  filters?: InputMaybe<CvContentHubTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvContentHubContentEntityResponseCollection = {
  nodes: Array<CvContentHubContent>;
  pageInfo: Pagination;
};

export type CvContentHubContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvContentHubContentFiltersInput>>>;
  author?: InputMaybe<StringFilterInput>;
  beginDate?: InputMaybe<DateFilterInput>;
  category?: InputMaybe<CvContentHubCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  detail?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  excerpt?: InputMaybe<StringFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  meta?: InputMaybe<ComponentSharedSeoFiltersInput>;
  not?: InputMaybe<CvContentHubContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvContentHubContentFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  tags?: InputMaybe<CvContentHubTagFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  youtubeId?: InputMaybe<StringFilterInput>;
};

export type CvContentHubContentInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<Scalars['ID']['input']>;
  draftOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<ComponentSharedSeoInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  thumbnailImage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  youtubeId?: InputMaybe<Scalars['String']['input']>;
};

export type CvContentHubContentRelationResponseCollection = {
  nodes: Array<CvContentHubContent>;
};

export type CvContentHubTag = {
  contents: Array<Maybe<CvContentHubContent>>;
  contents_connection?: Maybe<CvContentHubContentRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type CvContentHubTagContentsArgs = {
  filters?: InputMaybe<CvContentHubContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvContentHubTagContents_ConnectionArgs = {
  filters?: InputMaybe<CvContentHubContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvContentHubTagEntityResponseCollection = {
  nodes: Array<CvContentHubTag>;
  pageInfo: Pagination;
};

export type CvContentHubTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvContentHubTagFiltersInput>>>;
  contents?: InputMaybe<CvContentHubContentFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvContentHubTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvContentHubTagFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type CvContentHubTagInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CvContentHubTagRelationResponseCollection = {
  nodes: Array<CvContentHubTag>;
};

export type CvHomepage = {
  Splash?: Maybe<Array<Maybe<ComponentSplashSplashPopup>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  homeSpecialOfferConfig?: Maybe<Array<Maybe<ComponentSharedCvOfferOrder>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CvHomepageSplashArgs = {
  filters?: InputMaybe<ComponentSplashSplashPopupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvHomepageHomeSpecialOfferConfigArgs = {
  filters?: InputMaybe<ComponentSharedCvOfferOrderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvHomepageInput = {
  Splash?: InputMaybe<Array<InputMaybe<ComponentSplashSplashPopupInput>>>;
  homeSpecialOfferConfig?: InputMaybe<Array<InputMaybe<ComponentSharedCvOfferOrderInput>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type CvMaintenance = {
  classOneMarketingGrade?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  engineModel: Scalars['String']['output'];
  europeanEmissionStandard?: Maybe<Scalars['String']['output']>;
  maintenanceTableKey: Scalars['String']['output'];
  marketingModelYearBeginAndEnd: Scalars['String']['output'];
  modelYearBegin: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  regularMaintenanceSchedules: Array<Maybe<ComponentMaintenanceSchedule>>;
  remark?: Maybe<Scalars['String']['output']>;
  seriesMarketingModelName?: Maybe<Scalars['String']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleBodyType?: Maybe<Scalars['String']['output']>;
  vehicleGroup: Enum_Cvmaintenance_Vehiclegroup;
  vehicleModels?: Maybe<Array<Maybe<ComponentMaintenanceVehicleModel>>>;
  vehicleName: Scalars['String']['output'];
};


export type CvMaintenanceRegularMaintenanceSchedulesArgs = {
  filters?: InputMaybe<ComponentMaintenanceScheduleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvMaintenanceVehicleModelsArgs = {
  filters?: InputMaybe<ComponentMaintenanceVehicleModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvMaintenanceConfig = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  underTotalPriceRemark?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CvMaintenanceConfigInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  underTotalPriceRemark?: InputMaybe<Scalars['String']['input']>;
};

export type CvMaintenanceEntityResponseCollection = {
  nodes: Array<CvMaintenance>;
  pageInfo: Pagination;
};

export type CvMaintenanceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvMaintenanceFiltersInput>>>;
  classOneMarketingGrade?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  engineModel?: InputMaybe<StringFilterInput>;
  europeanEmissionStandard?: InputMaybe<StringFilterInput>;
  maintenanceTableKey?: InputMaybe<StringFilterInput>;
  marketingModelYearBeginAndEnd?: InputMaybe<StringFilterInput>;
  modelYearBegin?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvMaintenanceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvMaintenanceFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  regularMaintenanceSchedules?: InputMaybe<ComponentMaintenanceScheduleFiltersInput>;
  remark?: InputMaybe<StringFilterInput>;
  seriesMarketingModelName?: InputMaybe<StringFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  vehicleBodyType?: InputMaybe<StringFilterInput>;
  vehicleGroup?: InputMaybe<StringFilterInput>;
  vehicleModels?: InputMaybe<ComponentMaintenanceVehicleModelFiltersInput>;
  vehicleName?: InputMaybe<StringFilterInput>;
};

export type CvMaintenanceInput = {
  classOneMarketingGrade?: InputMaybe<Scalars['String']['input']>;
  engineModel?: InputMaybe<Scalars['String']['input']>;
  europeanEmissionStandard?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maintenanceTableKey?: InputMaybe<Scalars['String']['input']>;
  marketingModelYearBeginAndEnd?: InputMaybe<Scalars['String']['input']>;
  modelYearBegin?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  regularMaintenanceSchedules?: InputMaybe<Array<InputMaybe<ComponentMaintenanceScheduleInput>>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  seriesMarketingModelName?: InputMaybe<Scalars['String']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vehicleBodyType?: InputMaybe<Scalars['String']['input']>;
  vehicleGroup?: InputMaybe<Enum_Cvmaintenance_Vehiclegroup>;
  vehicleModels?: InputMaybe<Array<InputMaybe<ComponentMaintenanceVehicleModelInput>>>;
  vehicleName?: InputMaybe<Scalars['String']['input']>;
};

export type CvModel = {
  ce?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cv_model_class?: Maybe<CvModelClass>;
  documentId: Scalars['ID']['output'];
  finalGear?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CvModelCategory = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cv_model_sub_categories: Array<Maybe<CvModelSubCategory>>;
  cv_model_sub_categories_connection?: Maybe<CvModelSubCategoryRelationResponseCollection>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CvModelCategoryCv_Model_Sub_CategoriesArgs = {
  filters?: InputMaybe<CvModelSubCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelCategoryCv_Model_Sub_Categories_ConnectionArgs = {
  filters?: InputMaybe<CvModelSubCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvModelCategoryEntityResponseCollection = {
  nodes: Array<CvModelCategory>;
  pageInfo: Pagination;
};

export type CvModelCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvModelCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  cv_model_sub_categories?: InputMaybe<CvModelSubCategoryFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvModelCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvModelCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CvModelCategoryInput = {
  cv_model_sub_categories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type CvModelClass = {
  axleFinalGear?: Maybe<Scalars['String']['output']>;
  axleFrontCapacity?: Maybe<Scalars['String']['output']>;
  axleRearCapacity?: Maybe<Scalars['String']['output']>;
  bodyTypes: Array<Maybe<CvBodyType>>;
  bodyTypes_connection?: Maybe<CvBodyTypeRelationResponseCollection>;
  brake?: Maybe<Scalars['String']['output']>;
  brakeAuxilialy?: Maybe<Scalars['String']['output']>;
  brakeParking?: Maybe<Scalars['String']['output']>;
  brakeSafetySystem?: Maybe<Scalars['String']['output']>;
  brakeType?: Maybe<Scalars['String']['output']>;
  businessTypes: Array<Maybe<CvBusinessType>>;
  businessTypes_connection?: Maybe<CvBusinessTypeRelationResponseCollection>;
  category?: Maybe<CvModelCategory>;
  ce?: Maybe<Scalars['String']['output']>;
  ceRange?: Maybe<Scalars['String']['output']>;
  clutchControlSystem?: Maybe<Scalars['String']['output']>;
  clutchType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  electricAlternator?: Maybe<Scalars['String']['output']>;
  electricSystemBattery?: Maybe<Scalars['String']['output']>;
  engineDisplacementCc?: Maybe<Scalars['String']['output']>;
  engineMaxOuput?: Maybe<Scalars['String']['output']>;
  engineMaxTorque?: Maybe<Scalars['String']['output']>;
  engineName?: Maybe<Scalars['String']['output']>;
  engineNoOfCylinders?: Maybe<Scalars['String']['output']>;
  engineType?: Maybe<ComponentSharedEngineType>;
  finalGear?: Maybe<Scalars['String']['output']>;
  fuelTank?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  gear?: Maybe<Scalars['String']['output']>;
  image?: Maybe<UploadFile>;
  models: Array<Maybe<CvModel>>;
  models_connection?: Maybe<CvModelRelationResponseCollection>;
  name: Scalars['String']['output'];
  payload?: Maybe<Scalars['String']['output']>;
  performanceGradibility?: Maybe<Scalars['String']['output']>;
  performanceMaxSpeed?: Maybe<Scalars['String']['output']>;
  productButton?: Maybe<ComponentSharedButton>;
  ps?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  registerButton?: Maybe<ComponentSharedButton>;
  segmentTypes: Array<Maybe<CvSegmentType>>;
  segmentTypes_connection?: Maybe<CvSegmentTypeRelationResponseCollection>;
  showModelCe?: Maybe<Scalars['Boolean']['output']>;
  showModelFinalGear?: Maybe<Scalars['Boolean']['output']>;
  startPrice?: Maybe<Scalars['Int']['output']>;
  steeringMinturning?: Maybe<Scalars['String']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  subCategory?: Maybe<CvModelSubCategory>;
  title: Scalars['String']['output'];
  torque?: Maybe<Scalars['String']['output']>;
  transimissionModel?: Maybe<Scalars['String']['output']>;
  transmissionGearRatio?: Maybe<Scalars['String']['output']>;
  transmissionType?: Maybe<Scalars['String']['output']>;
  treatment?: Maybe<Scalars['String']['output']>;
  truckWeight?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wheelRims?: Maybe<Scalars['String']['output']>;
  wheelTires?: Maybe<Scalars['String']['output']>;
};


export type CvModelClassBodyTypesArgs = {
  filters?: InputMaybe<CvBodyTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelClassBodyTypes_ConnectionArgs = {
  filters?: InputMaybe<CvBodyTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelClassBusinessTypesArgs = {
  filters?: InputMaybe<CvBusinessTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelClassBusinessTypes_ConnectionArgs = {
  filters?: InputMaybe<CvBusinessTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelClassModelsArgs = {
  filters?: InputMaybe<CvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelClassModels_ConnectionArgs = {
  filters?: InputMaybe<CvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelClassSegmentTypesArgs = {
  filters?: InputMaybe<CvSegmentTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelClassSegmentTypes_ConnectionArgs = {
  filters?: InputMaybe<CvSegmentTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvModelClassEntityResponseCollection = {
  nodes: Array<CvModelClass>;
  pageInfo: Pagination;
};

export type CvModelClassFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvModelClassFiltersInput>>>;
  axleFinalGear?: InputMaybe<StringFilterInput>;
  axleFrontCapacity?: InputMaybe<StringFilterInput>;
  axleRearCapacity?: InputMaybe<StringFilterInput>;
  bodyTypes?: InputMaybe<CvBodyTypeFiltersInput>;
  brake?: InputMaybe<StringFilterInput>;
  brakeAuxilialy?: InputMaybe<StringFilterInput>;
  brakeParking?: InputMaybe<StringFilterInput>;
  brakeSafetySystem?: InputMaybe<StringFilterInput>;
  brakeType?: InputMaybe<StringFilterInput>;
  businessTypes?: InputMaybe<CvBusinessTypeFiltersInput>;
  category?: InputMaybe<CvModelCategoryFiltersInput>;
  ce?: InputMaybe<StringFilterInput>;
  ceRange?: InputMaybe<StringFilterInput>;
  clutchControlSystem?: InputMaybe<StringFilterInput>;
  clutchType?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  electricAlternator?: InputMaybe<StringFilterInput>;
  electricSystemBattery?: InputMaybe<StringFilterInput>;
  engineDisplacementCc?: InputMaybe<StringFilterInput>;
  engineMaxOuput?: InputMaybe<StringFilterInput>;
  engineMaxTorque?: InputMaybe<StringFilterInput>;
  engineName?: InputMaybe<StringFilterInput>;
  engineNoOfCylinders?: InputMaybe<StringFilterInput>;
  engineType?: InputMaybe<ComponentSharedEngineTypeFiltersInput>;
  finalGear?: InputMaybe<StringFilterInput>;
  fuelTank?: InputMaybe<StringFilterInput>;
  fuelType?: InputMaybe<StringFilterInput>;
  gear?: InputMaybe<StringFilterInput>;
  models?: InputMaybe<CvModelFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvModelClassFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvModelClassFiltersInput>>>;
  payload?: InputMaybe<StringFilterInput>;
  performanceGradibility?: InputMaybe<StringFilterInput>;
  performanceMaxSpeed?: InputMaybe<StringFilterInput>;
  productButton?: InputMaybe<ComponentSharedButtonFiltersInput>;
  ps?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  registerButton?: InputMaybe<ComponentSharedButtonFiltersInput>;
  segmentTypes?: InputMaybe<CvSegmentTypeFiltersInput>;
  showModelCe?: InputMaybe<BooleanFilterInput>;
  showModelFinalGear?: InputMaybe<BooleanFilterInput>;
  startPrice?: InputMaybe<IntFilterInput>;
  steeringMinturning?: InputMaybe<StringFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  subCategory?: InputMaybe<CvModelSubCategoryFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  torque?: InputMaybe<StringFilterInput>;
  transimissionModel?: InputMaybe<StringFilterInput>;
  transmissionGearRatio?: InputMaybe<StringFilterInput>;
  transmissionType?: InputMaybe<StringFilterInput>;
  treatment?: InputMaybe<StringFilterInput>;
  truckWeight?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  wheelRims?: InputMaybe<StringFilterInput>;
  wheelTires?: InputMaybe<StringFilterInput>;
};

export type CvModelClassInput = {
  axleFinalGear?: InputMaybe<Scalars['String']['input']>;
  axleFrontCapacity?: InputMaybe<Scalars['String']['input']>;
  axleRearCapacity?: InputMaybe<Scalars['String']['input']>;
  bodyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  brake?: InputMaybe<Scalars['String']['input']>;
  brakeAuxilialy?: InputMaybe<Scalars['String']['input']>;
  brakeParking?: InputMaybe<Scalars['String']['input']>;
  brakeSafetySystem?: InputMaybe<Scalars['String']['input']>;
  brakeType?: InputMaybe<Scalars['String']['input']>;
  businessTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  category?: InputMaybe<Scalars['ID']['input']>;
  ce?: InputMaybe<Scalars['String']['input']>;
  ceRange?: InputMaybe<Scalars['String']['input']>;
  clutchControlSystem?: InputMaybe<Scalars['String']['input']>;
  clutchType?: InputMaybe<Scalars['String']['input']>;
  electricAlternator?: InputMaybe<Scalars['String']['input']>;
  electricSystemBattery?: InputMaybe<Scalars['String']['input']>;
  engineDisplacementCc?: InputMaybe<Scalars['String']['input']>;
  engineMaxOuput?: InputMaybe<Scalars['String']['input']>;
  engineMaxTorque?: InputMaybe<Scalars['String']['input']>;
  engineName?: InputMaybe<Scalars['String']['input']>;
  engineNoOfCylinders?: InputMaybe<Scalars['String']['input']>;
  engineType?: InputMaybe<ComponentSharedEngineTypeInput>;
  finalGear?: InputMaybe<Scalars['String']['input']>;
  fuelTank?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  gear?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  models?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  performanceGradibility?: InputMaybe<Scalars['String']['input']>;
  performanceMaxSpeed?: InputMaybe<Scalars['String']['input']>;
  productButton?: InputMaybe<ComponentSharedButtonInput>;
  ps?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  registerButton?: InputMaybe<ComponentSharedButtonInput>;
  segmentTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  showModelCe?: InputMaybe<Scalars['Boolean']['input']>;
  showModelFinalGear?: InputMaybe<Scalars['Boolean']['input']>;
  startPrice?: InputMaybe<Scalars['Int']['input']>;
  steeringMinturning?: InputMaybe<Scalars['String']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  subCategory?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  torque?: InputMaybe<Scalars['String']['input']>;
  transimissionModel?: InputMaybe<Scalars['String']['input']>;
  transmissionGearRatio?: InputMaybe<Scalars['String']['input']>;
  transmissionType?: InputMaybe<Scalars['String']['input']>;
  treatment?: InputMaybe<Scalars['String']['input']>;
  truckWeight?: InputMaybe<Scalars['String']['input']>;
  wheelRims?: InputMaybe<Scalars['String']['input']>;
  wheelTires?: InputMaybe<Scalars['String']['input']>;
};

export type CvModelClassRelationResponseCollection = {
  nodes: Array<CvModelClass>;
};

export type CvModelConfig = {
  bodyTypes: Array<Maybe<CvBodyType>>;
  bodyTypes_connection?: Maybe<CvBodyTypeRelationResponseCollection>;
  businessTypes: Array<Maybe<CvBusinessType>>;
  businessTypes_connection?: Maybe<CvBusinessTypeRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  modelClassLineup?: Maybe<Array<Maybe<ComponentTruckTruckCategoryItems>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  segmentTypes: Array<Maybe<CvSegmentType>>;
  segmentTypes_connection?: Maybe<CvSegmentTypeRelationResponseCollection>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  subCategories: Array<Maybe<CvModelSubCategory>>;
  subCategories_connection?: Maybe<CvModelSubCategoryRelationResponseCollection>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CvModelConfigBodyTypesArgs = {
  filters?: InputMaybe<CvBodyTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelConfigBodyTypes_ConnectionArgs = {
  filters?: InputMaybe<CvBodyTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelConfigBusinessTypesArgs = {
  filters?: InputMaybe<CvBusinessTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelConfigBusinessTypes_ConnectionArgs = {
  filters?: InputMaybe<CvBusinessTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelConfigModelClassLineupArgs = {
  filters?: InputMaybe<ComponentTruckTruckCategoryItemsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelConfigSegmentTypesArgs = {
  filters?: InputMaybe<CvSegmentTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelConfigSegmentTypes_ConnectionArgs = {
  filters?: InputMaybe<CvSegmentTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelConfigSubCategoriesArgs = {
  filters?: InputMaybe<CvModelSubCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvModelConfigSubCategories_ConnectionArgs = {
  filters?: InputMaybe<CvModelSubCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvModelConfigInput = {
  bodyTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  businessTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  modelClassLineup?: InputMaybe<Array<InputMaybe<ComponentTruckTruckCategoryItemsInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  segmentTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  subCategories?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CvModelEntityResponseCollection = {
  nodes: Array<CvModel>;
  pageInfo: Pagination;
};

export type CvModelFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvModelFiltersInput>>>;
  ce?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  cv_model_class?: InputMaybe<CvModelClassFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  finalGear?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvModelFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvModelFiltersInput>>>;
  price?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CvModelInput = {
  ce?: InputMaybe<Scalars['String']['input']>;
  cv_model_class?: InputMaybe<Scalars['ID']['input']>;
  finalGear?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CvModelRelationResponseCollection = {
  nodes: Array<CvModel>;
};

export type CvModelSubCategory = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type CvModelSubCategoryEntityResponseCollection = {
  nodes: Array<CvModelSubCategory>;
  pageInfo: Pagination;
};

export type CvModelSubCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvModelSubCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvModelSubCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvModelSubCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type CvModelSubCategoryInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CvModelSubCategoryRelationResponseCollection = {
  nodes: Array<CvModelSubCategory>;
};

export type CvOffer = {
  beginDate: Scalars['Date']['output'];
  buttons?: Maybe<Array<Maybe<ComponentSharedButtonWithIcons>>>;
  category: CvOfferCategory;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  detailImage: UploadFile;
  documentId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  model?: Maybe<Enum_Cvoffer_Model>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  seo: ComponentSharedMeta;
  showFormRegister?: Maybe<Scalars['Boolean']['output']>;
  showInListPage: Scalars['Boolean']['output'];
  showInSpecialCampaigns: Scalars['Boolean']['output'];
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  thumbnailImage: UploadFile;
  title: Scalars['String']['output'];
  type?: Maybe<Enum_Cvoffer_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type CvOfferButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonWithIconsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvOfferCategory = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  offers: Array<Maybe<CvOffer>>;
  offers_connection?: Maybe<CvOfferRelationResponseCollection>;
  pinned?: Maybe<CvOffer>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type CvOfferCategoryOffersArgs = {
  filters?: InputMaybe<CvOfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvOfferCategoryOffers_ConnectionArgs = {
  filters?: InputMaybe<CvOfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvOfferCategoryEntityResponseCollection = {
  nodes: Array<CvOfferCategory>;
  pageInfo: Pagination;
};

export type CvOfferCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvOfferCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvOfferCategoryFiltersInput>;
  offers?: InputMaybe<CvOfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvOfferCategoryFiltersInput>>>;
  pinned?: InputMaybe<CvOfferFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type CvOfferCategoryInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pinned?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CvOfferCategoryRelationResponseCollection = {
  nodes: Array<CvOfferCategory>;
};

export type CvOfferConfig = {
  categoryOrder: Array<Maybe<CvOfferCategory>>;
  categoryOrder_connection?: Maybe<CvOfferCategoryRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  pinnedOffers: Array<Maybe<CvOffer>>;
  pinnedOffers_connection?: Maybe<CvOfferRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  showFinanceCategory: Scalars['Boolean']['output'];
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CvOfferConfigCategoryOrderArgs = {
  filters?: InputMaybe<CvOfferCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvOfferConfigCategoryOrder_ConnectionArgs = {
  filters?: InputMaybe<CvOfferCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvOfferConfigPinnedOffersArgs = {
  filters?: InputMaybe<CvOfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvOfferConfigPinnedOffers_ConnectionArgs = {
  filters?: InputMaybe<CvOfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvOfferConfigInput = {
  categoryOrder?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pinnedOffers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  showFinanceCategory?: InputMaybe<Scalars['Boolean']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type CvOfferEntityResponseCollection = {
  nodes: Array<CvOffer>;
  pageInfo: Pagination;
};

export type CvOfferFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvOfferFiltersInput>>>;
  beginDate?: InputMaybe<DateFilterInput>;
  buttons?: InputMaybe<ComponentSharedButtonWithIconsFiltersInput>;
  category?: InputMaybe<CvOfferCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  detail?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  model?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvOfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvOfferFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  remark?: InputMaybe<StringFilterInput>;
  seo?: InputMaybe<ComponentSharedMetaFiltersInput>;
  showFormRegister?: InputMaybe<BooleanFilterInput>;
  showInListPage?: InputMaybe<BooleanFilterInput>;
  showInSpecialCampaigns?: InputMaybe<BooleanFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type CvOfferInput = {
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<ComponentSharedButtonWithIconsInput>>>;
  category?: InputMaybe<Scalars['ID']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<Scalars['ID']['input']>;
  draftOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Enum_Cvoffer_Model>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<ComponentSharedMetaInput>;
  showFormRegister?: InputMaybe<Scalars['Boolean']['input']>;
  showInListPage?: InputMaybe<Scalars['Boolean']['input']>;
  showInSpecialCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  thumbnailImage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Cvoffer_Type>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CvOfferRelationResponseCollection = {
  nodes: Array<CvOffer>;
};

export type CvPartConfig = {
  categories?: Maybe<Array<Maybe<ComponentServicesPartCategoryItem>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleType: ComponentSharedVehicleType;
};


export type CvPartConfigCategoriesArgs = {
  filters?: InputMaybe<ComponentServicesPartCategoryItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvPartConfigInput = {
  categories?: InputMaybe<Array<InputMaybe<ComponentServicesPartCategoryItemInput>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<ComponentSharedVehicleTypeInput>;
};

export type CvSegmentType = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cv_model_classes: Array<Maybe<CvModelClass>>;
  cv_model_classes_connection?: Maybe<CvModelClassRelationResponseCollection>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CvSegmentTypeCv_Model_ClassesArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvSegmentTypeCv_Model_Classes_ConnectionArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvSegmentTypeEntityResponseCollection = {
  nodes: Array<CvSegmentType>;
  pageInfo: Pagination;
};

export type CvSegmentTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvSegmentTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  cv_model_classes?: InputMaybe<CvModelClassFiltersInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvSegmentTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvSegmentTypeFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CvSegmentTypeInput = {
  cv_model_classes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type CvSegmentTypeRelationResponseCollection = {
  nodes: Array<CvSegmentType>;
};

export type CvServiceCampaign = {
  beginDate: Scalars['DateTime']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  detailImage: UploadFile;
  documentId: Scalars['ID']['output'];
  endDate: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  isDetailAndThumbnailSameImage?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  seo?: Maybe<ComponentSharedMeta>;
  showAppointmentCta?: Maybe<Scalars['Boolean']['output']>;
  showInListPage?: Maybe<Scalars['Boolean']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  tabDetails: Array<Maybe<CvServiceCampaignTabDetail>>;
  tabDetails_connection?: Maybe<CvServiceCampaignTabDetailRelationResponseCollection>;
  thumbnailImage: UploadFile;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type CvServiceCampaignTabDetailsArgs = {
  filters?: InputMaybe<CvServiceCampaignTabDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvServiceCampaignTabDetails_ConnectionArgs = {
  filters?: InputMaybe<CvServiceCampaignTabDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvServiceCampaignEntityResponseCollection = {
  nodes: Array<CvServiceCampaign>;
  pageInfo: Pagination;
};

export type CvServiceCampaignFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvServiceCampaignFiltersInput>>>;
  beginDate?: InputMaybe<DateTimeFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateTimeFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  isDetailAndThumbnailSameImage?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<CvServiceCampaignFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvServiceCampaignFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  remark?: InputMaybe<StringFilterInput>;
  seo?: InputMaybe<ComponentSharedMetaFiltersInput>;
  showAppointmentCta?: InputMaybe<BooleanFilterInput>;
  showInListPage?: InputMaybe<BooleanFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  tabDetails?: InputMaybe<CvServiceCampaignTabDetailFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type CvServiceCampaignInput = {
  beginDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDetailAndThumbnailSameImage?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<ComponentSharedMetaInput>;
  showAppointmentCta?: InputMaybe<Scalars['Boolean']['input']>;
  showInListPage?: InputMaybe<Scalars['Boolean']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  tabDetails?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  thumbnailImage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CvServiceCampaignRelationResponseCollection = {
  nodes: Array<CvServiceCampaign>;
};

export type CvServiceCampaignTabDetail = {
  contentRows: Array<Maybe<CvServiceCampaignTabDetailContentRowsDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  serviceCampaign?: Maybe<CvServiceCampaign>;
  slug: Scalars['String']['output'];
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CvServiceCampaignTabDetailContentRowsDynamicZone = ComponentSharedComponentAccordion | ComponentSharedComponentDescription | ComponentSharedComponentHeader | ComponentSharedComponentHighlightCardGroup | ComponentSharedComponentHtmlTable | ComponentSharedComponentImageCardHorizontal | ComponentSharedComponentImageCardVertical | ComponentSharedComponentImageWithCta | ComponentSharedComponentResponsiveTable | ComponentSharedComponentTextCardGroup | ComponentSharedComponentTwoColumnsTable | ComponentSharedComponentYoutube | Error;

export type CvServiceCampaignTabDetailEntityResponseCollection = {
  nodes: Array<CvServiceCampaignTabDetail>;
  pageInfo: Pagination;
};

export type CvServiceCampaignTabDetailFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CvServiceCampaignTabDetailFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CvServiceCampaignTabDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CvServiceCampaignTabDetailFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  serviceCampaign?: InputMaybe<CvServiceCampaignFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CvServiceCampaignTabDetailInput = {
  contentRows?: InputMaybe<Array<Scalars['CvServiceCampaignTabDetailContentRowsDynamicZoneInput']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceCampaign?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type CvServiceCampaignTabDetailRelationResponseCollection = {
  nodes: Array<CvServiceCampaignTabDetail>;
};

export type CvServiceHomeConfig = {
  bannerItems?: Maybe<Array<Maybe<ComponentServicesServiceHomeItem>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CvServiceHomeConfigBannerItemsArgs = {
  filters?: InputMaybe<ComponentServicesServiceHomeItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvServiceHomeConfigInput = {
  bannerItems?: InputMaybe<Array<InputMaybe<ComponentServicesServiceHomeItemInput>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type CvServiceSpecialOfferConfig = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  pinnedOffers: Array<Maybe<CvServiceCampaign>>;
  pinnedOffers_connection?: Maybe<CvServiceCampaignRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CvServiceSpecialOfferConfigPinnedOffersArgs = {
  filters?: InputMaybe<CvServiceCampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CvServiceSpecialOfferConfigPinnedOffers_ConnectionArgs = {
  filters?: InputMaybe<CvServiceCampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CvServiceSpecialOfferConfigInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  pinnedOffers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteMutationResponse = {
  documentId: Scalars['ID']['output'];
};

export enum Enum_Componentnewsimages_Imagedisplay {
  OneColumn = 'one_column',
  TwoColumn = 'two_column'
}

export enum Enum_Componentnewsnewsdetailrow_Detailimagelayout {
  OneColumn = 'OneColumn',
  TwoColumn = 'TwoColumn'
}

export enum Enum_Componentnewsnewsdetailrow_Detailimageorientation {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical'
}

export enum Enum_Componentservicesgenuinepart_Genuineparttype {
  Bvp = 'bvp',
  Isuzu = 'isuzu',
  Part = 'part',
  Tripetch = 'tripetch'
}

export enum Enum_Componentsharedbuttonwithicons_Icon {
  ArrowForward = 'arrow_forward',
  Calculator = 'calculator',
  Compare = 'compare',
  FileDownload = 'file_download',
  Forum = 'forum',
  Map = 'map',
  PhotoLibrary = 'photo_library',
  Place = 'place',
  SteeringWheel = 'steering_wheel',
  Truck = 'truck'
}

export enum Enum_Componentsharedbuttonwithicons_Target {
  Blank = 'blank'
}

export enum Enum_Componentsharedbutton_Target {
  Blank = 'blank'
}

export enum Enum_Componentsharedcomponentdescription_Size {
  Normal = 'normal',
  Small = 'small'
}

export enum Enum_Componentsharedcomponentdescription_Textstyle {
  Black = 'black',
  Red = 'red'
}

export enum Enum_Componentsharedcomponentheader_Size {
  Level2 = 'level2',
  Level3 = 'level3'
}

export enum Enum_Componentsharedcomponentheader_Textstyle {
  Black = 'black',
  Red = 'red'
}

export enum Enum_Componentsharedcomponenthighlightcard_Textalignment {
  Center = 'center',
  Left = 'left'
}

export enum Enum_Componentsharedcomponenthtmltable_Dataalignment {
  Center = 'center',
  Left = 'left'
}

export enum Enum_Componentsharedcomponenthtmltable_Displaytype {
  FirstColumnTitle = 'firstColumnTitle',
  Responsive = 'responsive'
}

export enum Enum_Componentsharedcomponenthtmltable_Firstcolumntextstyle {
  Bold = 'bold',
  Normal = 'normal'
}

export enum Enum_Componentsharedcomponentimagecardhorizontal_Size {
  Normal = 'normal',
  Small = 'small'
}

export enum Enum_Componentsharedcomponentmymembertablebodyrow_Titlestyle {
  BoldBlack = 'boldBlack',
  BoldRed = 'boldRed',
  Default = 'default'
}

export enum Enum_Componentsharedcomponentmymembertablerank_Textstyle {
  BoldBlack = 'boldBlack',
  BoldRank = 'boldRank',
  BoldRed = 'boldRed',
  Default = 'default'
}

export enum Enum_Componentsharedcomponentmymembertablerank_Type {
  Link = 'link',
  Status = 'status',
  Text = 'text'
}

export enum Enum_Componentsharedcomponentresponsivetablebodycolumnsimpletext_Textalignment {
  Center = 'center',
  Left = 'left'
}

export enum Enum_Componentsharedcomponentresponsivetablebodycolumnsimpletext_Textstyle {
  BoldBlack = 'boldBlack',
  BoldRed = 'boldRed',
  Default = 'default'
}

export enum Enum_Componentsharedcomponentresponsivetablebodycolumnstatusgroup_Textstyle {
  BoldBlack = 'boldBlack',
  BoldRed = 'boldRed',
  Default = 'default'
}

export enum Enum_Componentsharedcomponentresponsivetablebodycolumn_Textareaalignment {
  Center = 'center',
  Left = 'left'
}

export enum Enum_Componentsharedcomponentresponsivetablebodycolumn_Type {
  SimpleText = 'simpleText',
  Status = 'status',
  Textarea = 'textarea'
}

export enum Enum_Componentsharedcomponentresponsivetable_Theme {
  Black = 'black',
  Red = 'red'
}

export enum Enum_Componentsharedcomponenttextcard_Theme {
  Black = 'black',
  Plain = 'plain',
  Red = 'red'
}

export enum Enum_Componentsharedenginetype_Type {
  Euro_3 = 'euro_3',
  Euro_5 = 'euro_5'
}

export enum Enum_Componentsharedmodelgroup_Type {
  Pickup = 'pickup',
  Ppv = 'ppv'
}

export enum Enum_Componentsharedvehicletype_Type {
  Cv = 'cv',
  Lcv = 'lcv'
}

export enum Enum_Cvmaintenance_Vehiclegroup {
  Cv = 'cv'
}

export enum Enum_Cvoffer_Model {
  Cab4 = 'cab4',
  DMax = 'd_max',
  HiLander_2Doors = 'hi_lander_2_doors',
  HiLander_4Doors = 'hi_lander_4_doors',
  MuX = 'mu_x',
  Spacecab = 'spacecab',
  Spark = 'spark',
  Spark4x4 = 'spark4x4',
  VCross = 'v_cross',
  XSeries = 'x_series'
}

export enum Enum_Cvoffer_Type {
  Pickup = 'pickup',
  Ppv = 'ppv'
}

export enum Enum_Lcvmaintenance_Vehiclegroup {
  Lcv = 'lcv'
}

export enum Enum_Lcvoffer_Model {
  Cab4 = 'cab4',
  DMax = 'd_max',
  HiLander_2Doors = 'hi_lander_2_doors',
  HiLander_4Doors = 'hi_lander_4_doors',
  MuX = 'mu_x',
  Spacecab = 'spacecab',
  Spark = 'spark',
  Spark4x4 = 'spark4x4',
  VCross = 'v_cross',
  XSeries = 'x_series'
}

export enum Enum_Lcvoffer_Type {
  Pickup = 'pickup',
  Ppv = 'ppv'
}

export enum Enum_Partitem_Vehicletype {
  Cv = 'cv',
  Lcv = 'lcv'
}

export enum Enum_Questionitem_Questiontype {
  Boolean = 'boolean',
  Scale = 'scale',
  Text = 'text'
}

export type Error = {
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph = ComponentLineupLcvCategoryModelItems | ComponentLineupLcvDefaultModelGradeByCategory | ComponentLineupLcvDefaultModelGradeBySubCategory | ComponentLineupLcvModelItem | ComponentMaintenancePartGroup | ComponentMaintenancePartItem | ComponentMaintenanceSchedule | ComponentMaintenanceVehicleModel | ComponentNewsHeader | ComponentNewsHighlighted | ComponentNewsImages | ComponentNewsNewsDetailRow | ComponentNewsNewsPinnedByCategory | ComponentNewsSingleImage | ComponentNewsTextContent | ComponentNewsYoutube | ComponentOmoCvOmoCategoryModelLineup | ComponentOmoCvOmoEngineLineup | ComponentOmoLcvOmoModelCategoryLineup | ComponentOmoLcvOmoYearLineup | ComponentServicesGenuinePart | ComponentServicesPartCategoryItem | ComponentServicesServiceHomeItem | ComponentSharedButton | ComponentSharedButtonWithIcons | ComponentSharedComponentAccordion | ComponentSharedComponentAccordionItem | ComponentSharedComponentDescription | ComponentSharedComponentHeader | ComponentSharedComponentHighlightCard | ComponentSharedComponentHighlightCardGroup | ComponentSharedComponentHtmlTable | ComponentSharedComponentImageCard | ComponentSharedComponentImageCardHorizontal | ComponentSharedComponentImageCardVertical | ComponentSharedComponentImageWithCta | ComponentSharedComponentMyMemberTable | ComponentSharedComponentMyMemberTableBodyRow | ComponentSharedComponentMyMemberTableRank | ComponentSharedComponentResponsiveTable | ComponentSharedComponentResponsiveTableBodyColumn | ComponentSharedComponentResponsiveTableBodyColumnSimpleText | ComponentSharedComponentResponsiveTableBodyColumnStatusGroup | ComponentSharedComponentResponsiveTableBodyRow | ComponentSharedComponentResponsiveTableHeaderCell | ComponentSharedComponentTextCard | ComponentSharedComponentTextCardGroup | ComponentSharedComponentTwoColumnsTable | ComponentSharedComponentTwoColumnsTableBodyRow | ComponentSharedComponentTwoColumnsTableHeader | ComponentSharedComponentYoutube | ComponentSharedCvOfferOrder | ComponentSharedDealerSearch | ComponentSharedEngineType | ComponentSharedLcvOfferOrder | ComponentSharedMeta | ComponentSharedModelGroup | ComponentSharedSeo | ComponentSharedTextItem | ComponentSharedVehicleType | ComponentSplashSplashPopup | ComponentSurveyScaleLabel | ComponentSurveySurveyItem | ComponentSurveySurveyVersion | ComponentTruckTruckCategoryItems | CvBodyType | CvBusinessType | CvContentHubCategory | CvContentHubConfig | CvContentHubContent | CvContentHubTag | CvHomepage | CvMaintenance | CvMaintenanceConfig | CvModel | CvModelCategory | CvModelClass | CvModelConfig | CvModelSubCategory | CvOffer | CvOfferCategory | CvOfferConfig | CvPartConfig | CvSegmentType | CvServiceCampaign | CvServiceCampaignTabDetail | CvServiceHomeConfig | CvServiceSpecialOfferConfig | I18NLocale | LcvColor | LcvContentHubCategory | LcvContentHubConfig | LcvContentHubContent | LcvContentHubTag | LcvHomepage | LcvInteriorColor | LcvMaintenance | LcvMaintenanceConfig | LcvModel | LcvModelCategory | LcvModelColor | LcvModelConfig | LcvModelSubCategory | LcvNewsCategory | LcvNewsConfig | LcvNewsDetail | LcvOffer | LcvOfferCategory | LcvOfferConfig | LcvPartConfig | LcvServiceCampaign | LcvServiceCampaignTabDetail | LcvServiceSpecialOfferConfig | LcvSpecialCampaign | OmoCvModelConfig | OmoLcvModelConfig | PartCategory | PartItem | QuestionItem | ReferralProgram | ReviewWorkflowsWorkflow | ReviewWorkflowsWorkflowStage | SurveyCsiConfig | SurveySsiConfig | UploadFile | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type I18NLocale = {
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntityResponseCollection = {
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type LcvColor = {
  colorCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  lcv_model_colors: Array<Maybe<LcvModelColor>>;
  lcv_model_colors_connection?: Maybe<LcvModelColorRelationResponseCollection>;
  nameEn: Scalars['String']['output'];
  nameTh: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LcvColorLcv_Model_ColorsArgs = {
  filters?: InputMaybe<LcvModelColorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvColorLcv_Model_Colors_ConnectionArgs = {
  filters?: InputMaybe<LcvModelColorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvColorEntityResponseCollection = {
  nodes: Array<LcvColor>;
  pageInfo: Pagination;
};

export type LcvColorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvColorFiltersInput>>>;
  colorCode?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lcv_model_colors?: InputMaybe<LcvModelColorFiltersInput>;
  nameEn?: InputMaybe<StringFilterInput>;
  nameTh?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvColorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvColorFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LcvColorInput = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  lcv_model_colors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameTh?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LcvContentHubCategory = {
  contents: Array<Maybe<LcvContentHubContent>>;
  contents_connection?: Maybe<LcvContentHubContentRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  headlineDescription: Scalars['String']['output'];
  headlineTitle: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  meta?: Maybe<ComponentSharedSeo>;
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type LcvContentHubCategoryContentsArgs = {
  filters?: InputMaybe<LcvContentHubContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvContentHubCategoryContents_ConnectionArgs = {
  filters?: InputMaybe<LcvContentHubContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvContentHubCategoryEntityResponseCollection = {
  nodes: Array<LcvContentHubCategory>;
  pageInfo: Pagination;
};

export type LcvContentHubCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvContentHubCategoryFiltersInput>>>;
  contents?: InputMaybe<LcvContentHubContentFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  headlineDescription?: InputMaybe<StringFilterInput>;
  headlineTitle?: InputMaybe<StringFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  meta?: InputMaybe<ComponentSharedSeoFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvContentHubCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvContentHubCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type LcvContentHubCategoryInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  headlineDescription?: InputMaybe<Scalars['String']['input']>;
  headlineTitle?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<ComponentSharedSeoInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LcvContentHubCategoryRelationResponseCollection = {
  nodes: Array<LcvContentHubCategory>;
};

export type LcvContentHubConfig = {
  categoryOrder: Array<Maybe<LcvContentHubCategory>>;
  categoryOrder_connection?: Maybe<LcvContentHubCategoryRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  enabled: Scalars['Boolean']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  tagOrder: Array<Maybe<LcvContentHubTag>>;
  tagOrder_connection?: Maybe<LcvContentHubTagRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LcvContentHubConfigCategoryOrderArgs = {
  filters?: InputMaybe<LcvContentHubCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvContentHubConfigCategoryOrder_ConnectionArgs = {
  filters?: InputMaybe<LcvContentHubCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvContentHubConfigTagOrderArgs = {
  filters?: InputMaybe<LcvContentHubTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvContentHubConfigTagOrder_ConnectionArgs = {
  filters?: InputMaybe<LcvContentHubTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvContentHubConfigInput = {
  categoryOrder?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  tagOrder?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type LcvContentHubContent = {
  author?: Maybe<Scalars['String']['output']>;
  beginDate: Scalars['Date']['output'];
  category: LcvContentHubCategory;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  detailImage: UploadFile;
  documentId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  meta?: Maybe<ComponentSharedSeo>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  tags: Array<Maybe<LcvContentHubTag>>;
  tags_connection: LcvContentHubTagRelationResponseCollection;
  thumbnailImage: UploadFile;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  youtubeId?: Maybe<Scalars['String']['output']>;
};


export type LcvContentHubContentTagsArgs = {
  filters?: InputMaybe<LcvContentHubTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvContentHubContentTags_ConnectionArgs = {
  filters?: InputMaybe<LcvContentHubTagFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvContentHubContentEntityResponseCollection = {
  nodes: Array<LcvContentHubContent>;
  pageInfo: Pagination;
};

export type LcvContentHubContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvContentHubContentFiltersInput>>>;
  author?: InputMaybe<StringFilterInput>;
  beginDate?: InputMaybe<DateFilterInput>;
  category?: InputMaybe<LcvContentHubCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  detail?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  excerpt?: InputMaybe<StringFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  meta?: InputMaybe<ComponentSharedSeoFiltersInput>;
  not?: InputMaybe<LcvContentHubContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvContentHubContentFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  tags?: InputMaybe<LcvContentHubTagFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  youtubeId?: InputMaybe<StringFilterInput>;
};

export type LcvContentHubContentInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<Scalars['ID']['input']>;
  draftOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<ComponentSharedSeoInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  thumbnailImage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  youtubeId?: InputMaybe<Scalars['String']['input']>;
};

export type LcvContentHubContentRelationResponseCollection = {
  nodes: Array<LcvContentHubContent>;
};

export type LcvContentHubTag = {
  contents: Array<Maybe<LcvContentHubContent>>;
  contents_connection?: Maybe<LcvContentHubContentRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type LcvContentHubTagContentsArgs = {
  filters?: InputMaybe<LcvContentHubContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvContentHubTagContents_ConnectionArgs = {
  filters?: InputMaybe<LcvContentHubContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvContentHubTagEntityResponseCollection = {
  nodes: Array<LcvContentHubTag>;
  pageInfo: Pagination;
};

export type LcvContentHubTagFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvContentHubTagFiltersInput>>>;
  contents?: InputMaybe<LcvContentHubContentFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvContentHubTagFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvContentHubTagFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type LcvContentHubTagInput = {
  contents?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LcvContentHubTagRelationResponseCollection = {
  nodes: Array<LcvContentHubTag>;
};

export type LcvHomepage = {
  Splash?: Maybe<Array<Maybe<ComponentSplashSplashPopup>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  homeSpecialOfferConfig?: Maybe<Array<Maybe<ComponentSharedLcvOfferOrder>>>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LcvHomepageSplashArgs = {
  filters?: InputMaybe<ComponentSplashSplashPopupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvHomepageHomeSpecialOfferConfigArgs = {
  filters?: InputMaybe<ComponentSharedLcvOfferOrderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvHomepageInput = {
  Splash?: InputMaybe<Array<InputMaybe<ComponentSplashSplashPopupInput>>>;
  homeSpecialOfferConfig?: InputMaybe<Array<InputMaybe<ComponentSharedLcvOfferOrderInput>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type LcvInteriorColor = {
  colorCodePrimary: Scalars['String']['output'];
  colorCodeSecondary?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  lcv_models: Array<Maybe<LcvModel>>;
  lcv_models_connection?: Maybe<LcvModelRelationResponseCollection>;
  nameEn?: Maybe<Scalars['String']['output']>;
  nameTh: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LcvInteriorColorLcv_ModelsArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvInteriorColorLcv_Models_ConnectionArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvInteriorColorEntityResponseCollection = {
  nodes: Array<LcvInteriorColor>;
  pageInfo: Pagination;
};

export type LcvInteriorColorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvInteriorColorFiltersInput>>>;
  colorCodePrimary?: InputMaybe<StringFilterInput>;
  colorCodeSecondary?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lcv_models?: InputMaybe<LcvModelFiltersInput>;
  nameEn?: InputMaybe<StringFilterInput>;
  nameTh?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvInteriorColorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvInteriorColorFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LcvInteriorColorInput = {
  colorCodePrimary?: InputMaybe<Scalars['String']['input']>;
  colorCodeSecondary?: InputMaybe<Scalars['String']['input']>;
  lcv_models?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameTh?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LcvMaintenance = {
  classOneMarketingGrade?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  driveSystem: Scalars['String']['output'];
  engineModel: Scalars['String']['output'];
  engineSize: Scalars['String']['output'];
  europeanEmissionStandard?: Maybe<Scalars['String']['output']>;
  maintenanceTableKey: Scalars['String']['output'];
  marketingModelYearBeginAndEnd: Scalars['String']['output'];
  modelYearBegin: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  regularMaintenanceSchedules: Array<Maybe<ComponentMaintenanceSchedule>>;
  remark?: Maybe<Scalars['String']['output']>;
  seriesMarketingModelName?: Maybe<Scalars['String']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  suggests?: Maybe<Array<Maybe<ComponentSharedTextItem>>>;
  title: Scalars['String']['output'];
  transmissionSystem: Scalars['String']['output'];
  uniqueSellingPoint?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleBodyType?: Maybe<Scalars['String']['output']>;
  vehicleGroup: Enum_Lcvmaintenance_Vehiclegroup;
  vehicleModels?: Maybe<Array<Maybe<ComponentMaintenanceVehicleModel>>>;
  vehicleName: Scalars['String']['output'];
};


export type LcvMaintenanceRegularMaintenanceSchedulesArgs = {
  filters?: InputMaybe<ComponentMaintenanceScheduleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvMaintenanceSuggestsArgs = {
  filters?: InputMaybe<ComponentSharedTextItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvMaintenanceVehicleModelsArgs = {
  filters?: InputMaybe<ComponentMaintenanceVehicleModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvMaintenanceConfig = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  underTotalPriceRemark?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LcvMaintenanceConfigInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  underTotalPriceRemark?: InputMaybe<Scalars['String']['input']>;
};

export type LcvMaintenanceEntityResponseCollection = {
  nodes: Array<LcvMaintenance>;
  pageInfo: Pagination;
};

export type LcvMaintenanceFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvMaintenanceFiltersInput>>>;
  classOneMarketingGrade?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  driveSystem?: InputMaybe<StringFilterInput>;
  engineModel?: InputMaybe<StringFilterInput>;
  engineSize?: InputMaybe<StringFilterInput>;
  europeanEmissionStandard?: InputMaybe<StringFilterInput>;
  maintenanceTableKey?: InputMaybe<StringFilterInput>;
  marketingModelYearBeginAndEnd?: InputMaybe<StringFilterInput>;
  modelYearBegin?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvMaintenanceFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvMaintenanceFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  regularMaintenanceSchedules?: InputMaybe<ComponentMaintenanceScheduleFiltersInput>;
  remark?: InputMaybe<StringFilterInput>;
  seriesMarketingModelName?: InputMaybe<StringFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  suggests?: InputMaybe<ComponentSharedTextItemFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  transmissionSystem?: InputMaybe<StringFilterInput>;
  uniqueSellingPoint?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  vehicleBodyType?: InputMaybe<StringFilterInput>;
  vehicleGroup?: InputMaybe<StringFilterInput>;
  vehicleModels?: InputMaybe<ComponentMaintenanceVehicleModelFiltersInput>;
  vehicleName?: InputMaybe<StringFilterInput>;
};

export type LcvMaintenanceInput = {
  classOneMarketingGrade?: InputMaybe<Scalars['String']['input']>;
  driveSystem?: InputMaybe<Scalars['String']['input']>;
  engineModel?: InputMaybe<Scalars['String']['input']>;
  engineSize?: InputMaybe<Scalars['String']['input']>;
  europeanEmissionStandard?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maintenanceTableKey?: InputMaybe<Scalars['String']['input']>;
  marketingModelYearBeginAndEnd?: InputMaybe<Scalars['String']['input']>;
  modelYearBegin?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  regularMaintenanceSchedules?: InputMaybe<Array<InputMaybe<ComponentMaintenanceScheduleInput>>>;
  remark?: InputMaybe<Scalars['String']['input']>;
  seriesMarketingModelName?: InputMaybe<Scalars['String']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  suggests?: InputMaybe<Array<InputMaybe<ComponentSharedTextItemInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  transmissionSystem?: InputMaybe<Scalars['String']['input']>;
  uniqueSellingPoint?: InputMaybe<Scalars['String']['input']>;
  vehicleBodyType?: InputMaybe<Scalars['String']['input']>;
  vehicleGroup?: InputMaybe<Enum_Lcvmaintenance_Vehiclegroup>;
  vehicleModels?: InputMaybe<Array<InputMaybe<ComponentMaintenanceVehicleModelInput>>>;
  vehicleName?: InputMaybe<Scalars['String']['input']>;
};

export type LcvModel = {
  biturboSign?: Maybe<Scalars['String']['output']>;
  brakeFront?: Maybe<Scalars['String']['output']>;
  brakeRear?: Maybe<Scalars['String']['output']>;
  category?: Maybe<LcvModelCategory>;
  colors: Array<Maybe<LcvModelColor>>;
  colors_connection?: Maybe<LcvModelColorRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  defaultColor?: Maybe<LcvModelColor>;
  dimensionApproxVehicleWeight?: Maybe<Scalars['String']['output']>;
  dimensionCargo?: Maybe<Scalars['String']['output']>;
  dimensionFrontRearTread?: Maybe<Scalars['String']['output']>;
  dimensionMinGroundClearance?: Maybe<Scalars['String']['output']>;
  dimensionVehicle?: Maybe<Scalars['String']['output']>;
  dimensionWheelBase?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  engineBoreWidthStroke?: Maybe<Scalars['String']['output']>;
  engineCompressionRatio?: Maybe<Scalars['String']['output']>;
  engineDisplacement?: Maybe<Scalars['String']['output']>;
  engineFuel?: Maybe<Scalars['String']['output']>;
  engineFuelTankCapacity?: Maybe<Scalars['String']['output']>;
  engineIssSystem?: Maybe<Scalars['String']['output']>;
  engineMaximumPower?: Maybe<Scalars['String']['output']>;
  engineMaximumTorque?: Maybe<Scalars['String']['output']>;
  engineModel?: Maybe<Scalars['String']['output']>;
  engineType?: Maybe<Scalars['String']['output']>;
  exteriorAntenna?: Maybe<Scalars['String']['output']>;
  exteriorAutoWiperSystem?: Maybe<Scalars['String']['output']>;
  exteriorBPillar?: Maybe<Scalars['String']['output']>;
  exteriorBackRoof?: Maybe<Scalars['String']['output']>;
  exteriorChromeMirrorEdge?: Maybe<Scalars['String']['output']>;
  exteriorDecorationSet?: Maybe<Scalars['String']['output']>;
  exteriorDoorHandle?: Maybe<Scalars['String']['output']>;
  exteriorElectricTailgateJamProtection?: Maybe<Scalars['String']['output']>;
  exteriorFollowMeHome?: Maybe<Scalars['String']['output']>;
  exteriorFrontBumper?: Maybe<Scalars['String']['output']>;
  exteriorFrontBumperDecoration?: Maybe<Scalars['String']['output']>;
  exteriorFrontFogLights?: Maybe<Scalars['String']['output']>;
  exteriorFrontGrille?: Maybe<Scalars['String']['output']>;
  exteriorFrontWiper?: Maybe<Scalars['String']['output']>;
  exteriorHeadLightsLevelSystem?: Maybe<Scalars['String']['output']>;
  exteriorHeadlights?: Maybe<Scalars['String']['output']>;
  exteriorPickupRimsAndTruckFloor?: Maybe<Scalars['String']['output']>;
  exteriorRear?: Maybe<Scalars['String']['output']>;
  exteriorRearBumper?: Maybe<Scalars['String']['output']>;
  exteriorRearWiper?: Maybe<Scalars['String']['output']>;
  exteriorRoofRail?: Maybe<Scalars['String']['output']>;
  exteriorRoofTrim?: Maybe<Scalars['String']['output']>;
  exteriorRsSign?: Maybe<Scalars['String']['output']>;
  exteriorSideMirror?: Maybe<Scalars['String']['output']>;
  exteriorSideSteps?: Maybe<Scalars['String']['output']>;
  exteriorStepSensor?: Maybe<Scalars['String']['output']>;
  exteriorTailLights?: Maybe<Scalars['String']['output']>;
  exteriorTurnOffAutoHeadLights?: Maybe<Scalars['String']['output']>;
  exteriorTwoToneRearSpoiler?: Maybe<Scalars['String']['output']>;
  exteriorWheeleArchDecoration?: Maybe<Scalars['String']['output']>;
  exteriorWindSheild?: Maybe<Scalars['String']['output']>;
  exteriorXSeriesOnRear?: Maybe<Scalars['String']['output']>;
  exteriorXseriesOnFender?: Maybe<Scalars['String']['output']>;
  hideFromCustomize?: Maybe<Scalars['Boolean']['output']>;
  interior?: Maybe<UploadFile>;
  interiorAdditionalUsbPowerOutlet?: Maybe<Scalars['String']['output']>;
  interiorAirConditioningSystem?: Maybe<Scalars['String']['output']>;
  interiorAirFilter?: Maybe<Scalars['String']['output']>;
  interiorAirVentsRearPassengers?: Maybe<Scalars['String']['output']>;
  interiorAssistAmbientLight?: Maybe<Scalars['String']['output']>;
  interiorAssistGrip?: Maybe<Scalars['String']['output']>;
  interiorAudioControlOnSteering?: Maybe<Scalars['String']['output']>;
  interiorAudioSystem?: Maybe<Scalars['String']['output']>;
  interiorCeilingMonitorRearPassengers?: Maybe<Scalars['String']['output']>;
  interiorCenterConsole?: Maybe<Scalars['String']['output']>;
  interiorCentralLocking?: Maybe<Scalars['String']['output']>;
  interiorCruiseControl?: Maybe<Scalars['String']['output']>;
  interiorDoamLight?: Maybe<Scalars['String']['output']>;
  interiorDoorAssistGrip?: Maybe<Scalars['String']['output']>;
  interiorDoorPanelDecoration?: Maybe<Scalars['String']['output']>;
  interiorFootLight?: Maybe<Scalars['String']['output']>;
  interiorFrontConsoleDecoration?: Maybe<Scalars['String']['output']>;
  interiorGarlandDecoration?: Maybe<Scalars['String']['output']>;
  interiorGauge?: Maybe<Scalars['String']['output']>;
  interiorGearShiftIndicatingSystem?: Maybe<Scalars['String']['output']>;
  interiorGlassesHolderWithLight?: Maybe<Scalars['String']['output']>;
  interiorInnerDoorHandle?: Maybe<Scalars['String']['output']>;
  interiorIntegratedRemoteKeyless?: Maybe<Scalars['String']['output']>;
  interiorIsuzuGeniusKeyPushStart?: Maybe<Scalars['String']['output']>;
  interiorLamp?: Maybe<Scalars['String']['output']>;
  interiorLuggageHanger?: Maybe<Scalars['String']['output']>;
  interiorMultiInfoDisplay?: Maybe<Scalars['String']['output']>;
  interiorMultipurposeHolder?: Maybe<Scalars['String']['output']>;
  interiorNavigationSystem?: Maybe<Scalars['String']['output']>;
  interiorNoOfSpeakers?: Maybe<Scalars['String']['output']>;
  interiorPaddleShift?: Maybe<Scalars['String']['output']>;
  interiorPowerSocket12Volt?: Maybe<Scalars['String']['output']>;
  interiorPowerSocket220Volt?: Maybe<Scalars['String']['output']>;
  interiorPowerWindows?: Maybe<Scalars['String']['output']>;
  interiorReadingLightsSeat2?: Maybe<Scalars['String']['output']>;
  interiorRearLuggageLight?: Maybe<Scalars['String']['output']>;
  interiorRemoteEngineStart?: Maybe<Scalars['String']['output']>;
  interiorSeatModelDocumentStorageCompartment?: Maybe<Scalars['String']['output']>;
  interiorSeatModelFrontCanAdjusted?: Maybe<Scalars['String']['output']>;
  interiorSeatModelMaterial?: Maybe<Scalars['String']['output']>;
  interiorSeatModelSeat2?: Maybe<Scalars['String']['output']>;
  interiorSeatModelSeat3?: Maybe<Scalars['String']['output']>;
  interiorSteeringWheel?: Maybe<Scalars['String']['output']>;
  interiorSteeringWheelMaterial?: Maybe<Scalars['String']['output']>;
  interiorSunshade?: Maybe<Scalars['String']['output']>;
  interiorTelephoneConnection?: Maybe<Scalars['String']['output']>;
  interiorUsbOrAuxDevice?: Maybe<Scalars['String']['output']>;
  interior_color?: Maybe<LcvInteriorColor>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  safety3rdBrakeLight?: Maybe<Scalars['String']['output']>;
  safety8PointsParkingSensors?: Maybe<Scalars['String']['output']>;
  safety360Camera?: Maybe<Scalars['String']['output']>;
  safetyAbsWithEbdAndBa?: Maybe<Scalars['String']['output']>;
  safetyAeb?: Maybe<Scalars['String']['output']>;
  safetyAhb?: Maybe<Scalars['String']['output']>;
  safetyAlarmForgetKey?: Maybe<Scalars['String']['output']>;
  safetyAntiTheftAlarm?: Maybe<Scalars['String']['output']>;
  safetyAttensionAssist?: Maybe<Scalars['String']['output']>;
  safetyBrakeOverrideSystem?: Maybe<Scalars['String']['output']>;
  safetyBsm?: Maybe<Scalars['String']['output']>;
  safetyCollapsibleBrakePedal?: Maybe<Scalars['String']['output']>;
  safetyDoorUnlockOnSrsAirbag?: Maybe<Scalars['String']['output']>;
  safetyElectricHandBrake?: Maybe<Scalars['String']['output']>;
  safetyElk?: Maybe<Scalars['String']['output']>;
  safetyEsc?: Maybe<Scalars['String']['output']>;
  safetyEssEmergencySignalSystem?: Maybe<Scalars['String']['output']>;
  safetyFcw?: Maybe<Scalars['String']['output']>;
  safetyFrontSeatBelt?: Maybe<Scalars['String']['output']>;
  safetyFrontSideAirbags?: Maybe<Scalars['String']['output']>;
  safetyHdc?: Maybe<Scalars['String']['output']>;
  safetyHsa?: Maybe<Scalars['String']['output']>;
  safetyIsofixMountingPoints?: Maybe<Scalars['String']['output']>;
  safetyLdp?: Maybe<Scalars['String']['output']>;
  safetyLdw?: Maybe<Scalars['String']['output']>;
  safetyLedDaytimeRunningLight?: Maybe<Scalars['String']['output']>;
  safetyLedTurningSignal?: Maybe<Scalars['String']['output']>;
  safetyLkas?: Maybe<Scalars['String']['output']>;
  safetyMcb?: Maybe<Scalars['String']['output']>;
  safetyMsl?: Maybe<Scalars['String']['output']>;
  safetyOneMotionUnlock?: Maybe<Scalars['String']['output']>;
  safetyPmm?: Maybe<Scalars['String']['output']>;
  safetyRcta?: Maybe<Scalars['String']['output']>;
  safetyRctaRctb?: Maybe<Scalars['String']['output']>;
  safetyRctb?: Maybe<Scalars['String']['output']>;
  safetyRearViewCamera?: Maybe<Scalars['String']['output']>;
  safetyRearViewMirrorWithAntiGlare?: Maybe<Scalars['String']['output']>;
  safetyRearWindowDefogger?: Maybe<Scalars['String']['output']>;
  safetySeatBelt2?: Maybe<Scalars['String']['output']>;
  safetySeatBelt3?: Maybe<Scalars['String']['output']>;
  safetySeatBeltReminder?: Maybe<Scalars['String']['output']>;
  safetySideAirbags?: Maybe<Scalars['String']['output']>;
  safetySideCurtainAirbags?: Maybe<Scalars['String']['output']>;
  safetySteelBeamDoor?: Maybe<Scalars['String']['output']>;
  safetyTcs?: Maybe<Scalars['String']['output']>;
  safetyTja?: Maybe<Scalars['String']['output']>;
  safetyTsc?: Maybe<Scalars['String']['output']>;
  safetyTurnAssist?: Maybe<Scalars['String']['output']>;
  safetyTurningSignalLights?: Maybe<Scalars['String']['output']>;
  safetyWalkAwayAutoDoorLock?: Maybe<Scalars['String']['output']>;
  safetyWarningTurnOffHeadlights?: Maybe<Scalars['String']['output']>;
  steeringMinTurningRadius?: Maybe<Scalars['String']['output']>;
  steeringType?: Maybe<Scalars['String']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  subCategory?: Maybe<LcvModelSubCategory>;
  summary360Camera?: Maybe<Scalars['String']['output']>;
  summaryAudioSystem?: Maybe<Scalars['String']['output']>;
  summaryEngine?: Maybe<Scalars['String']['output']>;
  summaryMaxTorque?: Maybe<Scalars['String']['output']>;
  summaryRearViewCamera?: Maybe<Scalars['String']['output']>;
  summarySeatMaterial?: Maybe<Scalars['String']['output']>;
  summaryWheel?: Maybe<Scalars['String']['output']>;
  suspensionFront?: Maybe<Scalars['String']['output']>;
  suspensionRear?: Maybe<Scalars['String']['output']>;
  tailgateLockKey?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  transmissionClutch?: Maybe<Scalars['String']['output']>;
  transmissionDifferentialGearLock?: Maybe<Scalars['String']['output']>;
  transmissionDriveSystem?: Maybe<Scalars['String']['output']>;
  transmissionFinalGearRatio?: Maybe<Scalars['String']['output']>;
  transmissionGear1?: Maybe<Scalars['String']['output']>;
  transmissionGear2?: Maybe<Scalars['String']['output']>;
  transmissionGear3?: Maybe<Scalars['String']['output']>;
  transmissionGear4?: Maybe<Scalars['String']['output']>;
  transmissionGear5?: Maybe<Scalars['String']['output']>;
  transmissionGear6?: Maybe<Scalars['String']['output']>;
  transmissionGear7?: Maybe<Scalars['String']['output']>;
  transmissionGear8?: Maybe<Scalars['String']['output']>;
  transmissionReverseGear?: Maybe<Scalars['String']['output']>;
  transmissionRoughTerrainMode?: Maybe<Scalars['String']['output']>;
  transmissionTransferGearRatio?: Maybe<Scalars['String']['output']>;
  transmissionType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wheel?: Maybe<Scalars['String']['output']>;
  wheelSpareTire?: Maybe<Scalars['String']['output']>;
  wheelTireSize?: Maybe<Scalars['String']['output']>;
};


export type LcvModelColorsArgs = {
  filters?: InputMaybe<LcvModelColorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvModelColors_ConnectionArgs = {
  filters?: InputMaybe<LcvModelColorFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvModelCategory = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  lcv_models: Array<Maybe<LcvModel>>;
  lcv_models_connection?: Maybe<LcvModelRelationResponseCollection>;
  modelGroup?: Maybe<ComponentSharedModelGroup>;
  nameEn: Scalars['String']['output'];
  nameTh: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LcvModelCategoryLcv_ModelsArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvModelCategoryLcv_Models_ConnectionArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvModelCategoryEntityResponseCollection = {
  nodes: Array<LcvModelCategory>;
  pageInfo: Pagination;
};

export type LcvModelCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvModelCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lcv_models?: InputMaybe<LcvModelFiltersInput>;
  modelGroup?: InputMaybe<ComponentSharedModelGroupFiltersInput>;
  nameEn?: InputMaybe<StringFilterInput>;
  nameTh?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvModelCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvModelCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LcvModelCategoryInput = {
  lcv_models?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  modelGroup?: InputMaybe<ComponentSharedModelGroupInput>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameTh?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LcvModelColor = {
  color?: Maybe<LcvColor>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  front?: Maybe<UploadFile>;
  lcv_model?: Maybe<LcvModel>;
  price?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  rear?: Maybe<UploadFile>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LcvModelColorEntityResponseCollection = {
  nodes: Array<LcvModelColor>;
  pageInfo: Pagination;
};

export type LcvModelColorFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvModelColorFiltersInput>>>;
  color?: InputMaybe<LcvColorFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lcv_model?: InputMaybe<LcvModelFiltersInput>;
  not?: InputMaybe<LcvModelColorFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvModelColorFiltersInput>>>;
  price?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LcvModelColorInput = {
  color?: InputMaybe<Scalars['ID']['input']>;
  front?: InputMaybe<Scalars['ID']['input']>;
  lcv_model?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rear?: InputMaybe<Scalars['ID']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LcvModelColorRelationResponseCollection = {
  nodes: Array<LcvModelColor>;
};

export type LcvModelConfig = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  yearLineupModels?: Maybe<Array<Maybe<ComponentLineupLcvCategoryModelItems>>>;
};


export type LcvModelConfigYearLineupModelsArgs = {
  filters?: InputMaybe<ComponentLineupLcvCategoryModelItemsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvModelConfigInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  yearLineupModels?: InputMaybe<Array<InputMaybe<ComponentLineupLcvCategoryModelItemsInput>>>;
};

export type LcvModelEntityResponseCollection = {
  nodes: Array<LcvModel>;
  pageInfo: Pagination;
};

export type LcvModelFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvModelFiltersInput>>>;
  biturboSign?: InputMaybe<StringFilterInput>;
  brakeFront?: InputMaybe<StringFilterInput>;
  brakeRear?: InputMaybe<StringFilterInput>;
  category?: InputMaybe<LcvModelCategoryFiltersInput>;
  colors?: InputMaybe<LcvModelColorFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  defaultColor?: InputMaybe<LcvModelColorFiltersInput>;
  dimensionApproxVehicleWeight?: InputMaybe<StringFilterInput>;
  dimensionCargo?: InputMaybe<StringFilterInput>;
  dimensionFrontRearTread?: InputMaybe<StringFilterInput>;
  dimensionMinGroundClearance?: InputMaybe<StringFilterInput>;
  dimensionVehicle?: InputMaybe<StringFilterInput>;
  dimensionWheelBase?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  engineBoreWidthStroke?: InputMaybe<StringFilterInput>;
  engineCompressionRatio?: InputMaybe<StringFilterInput>;
  engineDisplacement?: InputMaybe<StringFilterInput>;
  engineFuel?: InputMaybe<StringFilterInput>;
  engineFuelTankCapacity?: InputMaybe<StringFilterInput>;
  engineIssSystem?: InputMaybe<StringFilterInput>;
  engineMaximumPower?: InputMaybe<StringFilterInput>;
  engineMaximumTorque?: InputMaybe<StringFilterInput>;
  engineModel?: InputMaybe<StringFilterInput>;
  engineType?: InputMaybe<StringFilterInput>;
  exteriorAntenna?: InputMaybe<StringFilterInput>;
  exteriorAutoWiperSystem?: InputMaybe<StringFilterInput>;
  exteriorBPillar?: InputMaybe<StringFilterInput>;
  exteriorBackRoof?: InputMaybe<StringFilterInput>;
  exteriorChromeMirrorEdge?: InputMaybe<StringFilterInput>;
  exteriorDecorationSet?: InputMaybe<StringFilterInput>;
  exteriorDoorHandle?: InputMaybe<StringFilterInput>;
  exteriorElectricTailgateJamProtection?: InputMaybe<StringFilterInput>;
  exteriorFollowMeHome?: InputMaybe<StringFilterInput>;
  exteriorFrontBumper?: InputMaybe<StringFilterInput>;
  exteriorFrontBumperDecoration?: InputMaybe<StringFilterInput>;
  exteriorFrontFogLights?: InputMaybe<StringFilterInput>;
  exteriorFrontGrille?: InputMaybe<StringFilterInput>;
  exteriorFrontWiper?: InputMaybe<StringFilterInput>;
  exteriorHeadLightsLevelSystem?: InputMaybe<StringFilterInput>;
  exteriorHeadlights?: InputMaybe<StringFilterInput>;
  exteriorPickupRimsAndTruckFloor?: InputMaybe<StringFilterInput>;
  exteriorRear?: InputMaybe<StringFilterInput>;
  exteriorRearBumper?: InputMaybe<StringFilterInput>;
  exteriorRearWiper?: InputMaybe<StringFilterInput>;
  exteriorRoofRail?: InputMaybe<StringFilterInput>;
  exteriorRoofTrim?: InputMaybe<StringFilterInput>;
  exteriorRsSign?: InputMaybe<StringFilterInput>;
  exteriorSideMirror?: InputMaybe<StringFilterInput>;
  exteriorSideSteps?: InputMaybe<StringFilterInput>;
  exteriorStepSensor?: InputMaybe<StringFilterInput>;
  exteriorTailLights?: InputMaybe<StringFilterInput>;
  exteriorTurnOffAutoHeadLights?: InputMaybe<StringFilterInput>;
  exteriorTwoToneRearSpoiler?: InputMaybe<StringFilterInput>;
  exteriorWheeleArchDecoration?: InputMaybe<StringFilterInput>;
  exteriorWindSheild?: InputMaybe<StringFilterInput>;
  exteriorXSeriesOnRear?: InputMaybe<StringFilterInput>;
  exteriorXseriesOnFender?: InputMaybe<StringFilterInput>;
  hideFromCustomize?: InputMaybe<BooleanFilterInput>;
  interiorAdditionalUsbPowerOutlet?: InputMaybe<StringFilterInput>;
  interiorAirConditioningSystem?: InputMaybe<StringFilterInput>;
  interiorAirFilter?: InputMaybe<StringFilterInput>;
  interiorAirVentsRearPassengers?: InputMaybe<StringFilterInput>;
  interiorAssistAmbientLight?: InputMaybe<StringFilterInput>;
  interiorAssistGrip?: InputMaybe<StringFilterInput>;
  interiorAudioControlOnSteering?: InputMaybe<StringFilterInput>;
  interiorAudioSystem?: InputMaybe<StringFilterInput>;
  interiorCeilingMonitorRearPassengers?: InputMaybe<StringFilterInput>;
  interiorCenterConsole?: InputMaybe<StringFilterInput>;
  interiorCentralLocking?: InputMaybe<StringFilterInput>;
  interiorCruiseControl?: InputMaybe<StringFilterInput>;
  interiorDoamLight?: InputMaybe<StringFilterInput>;
  interiorDoorAssistGrip?: InputMaybe<StringFilterInput>;
  interiorDoorPanelDecoration?: InputMaybe<StringFilterInput>;
  interiorFootLight?: InputMaybe<StringFilterInput>;
  interiorFrontConsoleDecoration?: InputMaybe<StringFilterInput>;
  interiorGarlandDecoration?: InputMaybe<StringFilterInput>;
  interiorGauge?: InputMaybe<StringFilterInput>;
  interiorGearShiftIndicatingSystem?: InputMaybe<StringFilterInput>;
  interiorGlassesHolderWithLight?: InputMaybe<StringFilterInput>;
  interiorInnerDoorHandle?: InputMaybe<StringFilterInput>;
  interiorIntegratedRemoteKeyless?: InputMaybe<StringFilterInput>;
  interiorIsuzuGeniusKeyPushStart?: InputMaybe<StringFilterInput>;
  interiorLamp?: InputMaybe<StringFilterInput>;
  interiorLuggageHanger?: InputMaybe<StringFilterInput>;
  interiorMultiInfoDisplay?: InputMaybe<StringFilterInput>;
  interiorMultipurposeHolder?: InputMaybe<StringFilterInput>;
  interiorNavigationSystem?: InputMaybe<StringFilterInput>;
  interiorNoOfSpeakers?: InputMaybe<StringFilterInput>;
  interiorPaddleShift?: InputMaybe<StringFilterInput>;
  interiorPowerSocket12Volt?: InputMaybe<StringFilterInput>;
  interiorPowerSocket220Volt?: InputMaybe<StringFilterInput>;
  interiorPowerWindows?: InputMaybe<StringFilterInput>;
  interiorReadingLightsSeat2?: InputMaybe<StringFilterInput>;
  interiorRearLuggageLight?: InputMaybe<StringFilterInput>;
  interiorRemoteEngineStart?: InputMaybe<StringFilterInput>;
  interiorSeatModelDocumentStorageCompartment?: InputMaybe<StringFilterInput>;
  interiorSeatModelFrontCanAdjusted?: InputMaybe<StringFilterInput>;
  interiorSeatModelMaterial?: InputMaybe<StringFilterInput>;
  interiorSeatModelSeat2?: InputMaybe<StringFilterInput>;
  interiorSeatModelSeat3?: InputMaybe<StringFilterInput>;
  interiorSteeringWheel?: InputMaybe<StringFilterInput>;
  interiorSteeringWheelMaterial?: InputMaybe<StringFilterInput>;
  interiorSunshade?: InputMaybe<StringFilterInput>;
  interiorTelephoneConnection?: InputMaybe<StringFilterInput>;
  interiorUsbOrAuxDevice?: InputMaybe<StringFilterInput>;
  interior_color?: InputMaybe<LcvInteriorColorFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvModelFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvModelFiltersInput>>>;
  price?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  safety3rdBrakeLight?: InputMaybe<StringFilterInput>;
  safety8PointsParkingSensors?: InputMaybe<StringFilterInput>;
  safety360Camera?: InputMaybe<StringFilterInput>;
  safetyAbsWithEbdAndBa?: InputMaybe<StringFilterInput>;
  safetyAeb?: InputMaybe<StringFilterInput>;
  safetyAhb?: InputMaybe<StringFilterInput>;
  safetyAlarmForgetKey?: InputMaybe<StringFilterInput>;
  safetyAntiTheftAlarm?: InputMaybe<StringFilterInput>;
  safetyAttensionAssist?: InputMaybe<StringFilterInput>;
  safetyBrakeOverrideSystem?: InputMaybe<StringFilterInput>;
  safetyBsm?: InputMaybe<StringFilterInput>;
  safetyCollapsibleBrakePedal?: InputMaybe<StringFilterInput>;
  safetyDoorUnlockOnSrsAirbag?: InputMaybe<StringFilterInput>;
  safetyElectricHandBrake?: InputMaybe<StringFilterInput>;
  safetyElk?: InputMaybe<StringFilterInput>;
  safetyEsc?: InputMaybe<StringFilterInput>;
  safetyEssEmergencySignalSystem?: InputMaybe<StringFilterInput>;
  safetyFcw?: InputMaybe<StringFilterInput>;
  safetyFrontSeatBelt?: InputMaybe<StringFilterInput>;
  safetyFrontSideAirbags?: InputMaybe<StringFilterInput>;
  safetyHdc?: InputMaybe<StringFilterInput>;
  safetyHsa?: InputMaybe<StringFilterInput>;
  safetyIsofixMountingPoints?: InputMaybe<StringFilterInput>;
  safetyLdp?: InputMaybe<StringFilterInput>;
  safetyLdw?: InputMaybe<StringFilterInput>;
  safetyLedDaytimeRunningLight?: InputMaybe<StringFilterInput>;
  safetyLedTurningSignal?: InputMaybe<StringFilterInput>;
  safetyLkas?: InputMaybe<StringFilterInput>;
  safetyMcb?: InputMaybe<StringFilterInput>;
  safetyMsl?: InputMaybe<StringFilterInput>;
  safetyOneMotionUnlock?: InputMaybe<StringFilterInput>;
  safetyPmm?: InputMaybe<StringFilterInput>;
  safetyRcta?: InputMaybe<StringFilterInput>;
  safetyRctaRctb?: InputMaybe<StringFilterInput>;
  safetyRctb?: InputMaybe<StringFilterInput>;
  safetyRearViewCamera?: InputMaybe<StringFilterInput>;
  safetyRearViewMirrorWithAntiGlare?: InputMaybe<StringFilterInput>;
  safetyRearWindowDefogger?: InputMaybe<StringFilterInput>;
  safetySeatBelt2?: InputMaybe<StringFilterInput>;
  safetySeatBelt3?: InputMaybe<StringFilterInput>;
  safetySeatBeltReminder?: InputMaybe<StringFilterInput>;
  safetySideAirbags?: InputMaybe<StringFilterInput>;
  safetySideCurtainAirbags?: InputMaybe<StringFilterInput>;
  safetySteelBeamDoor?: InputMaybe<StringFilterInput>;
  safetyTcs?: InputMaybe<StringFilterInput>;
  safetyTja?: InputMaybe<StringFilterInput>;
  safetyTsc?: InputMaybe<StringFilterInput>;
  safetyTurnAssist?: InputMaybe<StringFilterInput>;
  safetyTurningSignalLights?: InputMaybe<StringFilterInput>;
  safetyWalkAwayAutoDoorLock?: InputMaybe<StringFilterInput>;
  safetyWarningTurnOffHeadlights?: InputMaybe<StringFilterInput>;
  steeringMinTurningRadius?: InputMaybe<StringFilterInput>;
  steeringType?: InputMaybe<StringFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  subCategory?: InputMaybe<LcvModelSubCategoryFiltersInput>;
  summary360Camera?: InputMaybe<StringFilterInput>;
  summaryAudioSystem?: InputMaybe<StringFilterInput>;
  summaryEngine?: InputMaybe<StringFilterInput>;
  summaryMaxTorque?: InputMaybe<StringFilterInput>;
  summaryRearViewCamera?: InputMaybe<StringFilterInput>;
  summarySeatMaterial?: InputMaybe<StringFilterInput>;
  summaryWheel?: InputMaybe<StringFilterInput>;
  suspensionFront?: InputMaybe<StringFilterInput>;
  suspensionRear?: InputMaybe<StringFilterInput>;
  tailgateLockKey?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  transmissionClutch?: InputMaybe<StringFilterInput>;
  transmissionDifferentialGearLock?: InputMaybe<StringFilterInput>;
  transmissionDriveSystem?: InputMaybe<StringFilterInput>;
  transmissionFinalGearRatio?: InputMaybe<StringFilterInput>;
  transmissionGear1?: InputMaybe<StringFilterInput>;
  transmissionGear2?: InputMaybe<StringFilterInput>;
  transmissionGear3?: InputMaybe<StringFilterInput>;
  transmissionGear4?: InputMaybe<StringFilterInput>;
  transmissionGear5?: InputMaybe<StringFilterInput>;
  transmissionGear6?: InputMaybe<StringFilterInput>;
  transmissionGear7?: InputMaybe<StringFilterInput>;
  transmissionGear8?: InputMaybe<StringFilterInput>;
  transmissionReverseGear?: InputMaybe<StringFilterInput>;
  transmissionRoughTerrainMode?: InputMaybe<StringFilterInput>;
  transmissionTransferGearRatio?: InputMaybe<StringFilterInput>;
  transmissionType?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  wheel?: InputMaybe<StringFilterInput>;
  wheelSpareTire?: InputMaybe<StringFilterInput>;
  wheelTireSize?: InputMaybe<StringFilterInput>;
};

export type LcvModelInput = {
  biturboSign?: InputMaybe<Scalars['String']['input']>;
  brakeFront?: InputMaybe<Scalars['String']['input']>;
  brakeRear?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  defaultColor?: InputMaybe<Scalars['ID']['input']>;
  dimensionApproxVehicleWeight?: InputMaybe<Scalars['String']['input']>;
  dimensionCargo?: InputMaybe<Scalars['String']['input']>;
  dimensionFrontRearTread?: InputMaybe<Scalars['String']['input']>;
  dimensionMinGroundClearance?: InputMaybe<Scalars['String']['input']>;
  dimensionVehicle?: InputMaybe<Scalars['String']['input']>;
  dimensionWheelBase?: InputMaybe<Scalars['String']['input']>;
  engineBoreWidthStroke?: InputMaybe<Scalars['String']['input']>;
  engineCompressionRatio?: InputMaybe<Scalars['String']['input']>;
  engineDisplacement?: InputMaybe<Scalars['String']['input']>;
  engineFuel?: InputMaybe<Scalars['String']['input']>;
  engineFuelTankCapacity?: InputMaybe<Scalars['String']['input']>;
  engineIssSystem?: InputMaybe<Scalars['String']['input']>;
  engineMaximumPower?: InputMaybe<Scalars['String']['input']>;
  engineMaximumTorque?: InputMaybe<Scalars['String']['input']>;
  engineModel?: InputMaybe<Scalars['String']['input']>;
  engineType?: InputMaybe<Scalars['String']['input']>;
  exteriorAntenna?: InputMaybe<Scalars['String']['input']>;
  exteriorAutoWiperSystem?: InputMaybe<Scalars['String']['input']>;
  exteriorBPillar?: InputMaybe<Scalars['String']['input']>;
  exteriorBackRoof?: InputMaybe<Scalars['String']['input']>;
  exteriorChromeMirrorEdge?: InputMaybe<Scalars['String']['input']>;
  exteriorDecorationSet?: InputMaybe<Scalars['String']['input']>;
  exteriorDoorHandle?: InputMaybe<Scalars['String']['input']>;
  exteriorElectricTailgateJamProtection?: InputMaybe<Scalars['String']['input']>;
  exteriorFollowMeHome?: InputMaybe<Scalars['String']['input']>;
  exteriorFrontBumper?: InputMaybe<Scalars['String']['input']>;
  exteriorFrontBumperDecoration?: InputMaybe<Scalars['String']['input']>;
  exteriorFrontFogLights?: InputMaybe<Scalars['String']['input']>;
  exteriorFrontGrille?: InputMaybe<Scalars['String']['input']>;
  exteriorFrontWiper?: InputMaybe<Scalars['String']['input']>;
  exteriorHeadLightsLevelSystem?: InputMaybe<Scalars['String']['input']>;
  exteriorHeadlights?: InputMaybe<Scalars['String']['input']>;
  exteriorPickupRimsAndTruckFloor?: InputMaybe<Scalars['String']['input']>;
  exteriorRear?: InputMaybe<Scalars['String']['input']>;
  exteriorRearBumper?: InputMaybe<Scalars['String']['input']>;
  exteriorRearWiper?: InputMaybe<Scalars['String']['input']>;
  exteriorRoofRail?: InputMaybe<Scalars['String']['input']>;
  exteriorRoofTrim?: InputMaybe<Scalars['String']['input']>;
  exteriorRsSign?: InputMaybe<Scalars['String']['input']>;
  exteriorSideMirror?: InputMaybe<Scalars['String']['input']>;
  exteriorSideSteps?: InputMaybe<Scalars['String']['input']>;
  exteriorStepSensor?: InputMaybe<Scalars['String']['input']>;
  exteriorTailLights?: InputMaybe<Scalars['String']['input']>;
  exteriorTurnOffAutoHeadLights?: InputMaybe<Scalars['String']['input']>;
  exteriorTwoToneRearSpoiler?: InputMaybe<Scalars['String']['input']>;
  exteriorWheeleArchDecoration?: InputMaybe<Scalars['String']['input']>;
  exteriorWindSheild?: InputMaybe<Scalars['String']['input']>;
  exteriorXSeriesOnRear?: InputMaybe<Scalars['String']['input']>;
  exteriorXseriesOnFender?: InputMaybe<Scalars['String']['input']>;
  hideFromCustomize?: InputMaybe<Scalars['Boolean']['input']>;
  interior?: InputMaybe<Scalars['ID']['input']>;
  interiorAdditionalUsbPowerOutlet?: InputMaybe<Scalars['String']['input']>;
  interiorAirConditioningSystem?: InputMaybe<Scalars['String']['input']>;
  interiorAirFilter?: InputMaybe<Scalars['String']['input']>;
  interiorAirVentsRearPassengers?: InputMaybe<Scalars['String']['input']>;
  interiorAssistAmbientLight?: InputMaybe<Scalars['String']['input']>;
  interiorAssistGrip?: InputMaybe<Scalars['String']['input']>;
  interiorAudioControlOnSteering?: InputMaybe<Scalars['String']['input']>;
  interiorAudioSystem?: InputMaybe<Scalars['String']['input']>;
  interiorCeilingMonitorRearPassengers?: InputMaybe<Scalars['String']['input']>;
  interiorCenterConsole?: InputMaybe<Scalars['String']['input']>;
  interiorCentralLocking?: InputMaybe<Scalars['String']['input']>;
  interiorCruiseControl?: InputMaybe<Scalars['String']['input']>;
  interiorDoamLight?: InputMaybe<Scalars['String']['input']>;
  interiorDoorAssistGrip?: InputMaybe<Scalars['String']['input']>;
  interiorDoorPanelDecoration?: InputMaybe<Scalars['String']['input']>;
  interiorFootLight?: InputMaybe<Scalars['String']['input']>;
  interiorFrontConsoleDecoration?: InputMaybe<Scalars['String']['input']>;
  interiorGarlandDecoration?: InputMaybe<Scalars['String']['input']>;
  interiorGauge?: InputMaybe<Scalars['String']['input']>;
  interiorGearShiftIndicatingSystem?: InputMaybe<Scalars['String']['input']>;
  interiorGlassesHolderWithLight?: InputMaybe<Scalars['String']['input']>;
  interiorInnerDoorHandle?: InputMaybe<Scalars['String']['input']>;
  interiorIntegratedRemoteKeyless?: InputMaybe<Scalars['String']['input']>;
  interiorIsuzuGeniusKeyPushStart?: InputMaybe<Scalars['String']['input']>;
  interiorLamp?: InputMaybe<Scalars['String']['input']>;
  interiorLuggageHanger?: InputMaybe<Scalars['String']['input']>;
  interiorMultiInfoDisplay?: InputMaybe<Scalars['String']['input']>;
  interiorMultipurposeHolder?: InputMaybe<Scalars['String']['input']>;
  interiorNavigationSystem?: InputMaybe<Scalars['String']['input']>;
  interiorNoOfSpeakers?: InputMaybe<Scalars['String']['input']>;
  interiorPaddleShift?: InputMaybe<Scalars['String']['input']>;
  interiorPowerSocket12Volt?: InputMaybe<Scalars['String']['input']>;
  interiorPowerSocket220Volt?: InputMaybe<Scalars['String']['input']>;
  interiorPowerWindows?: InputMaybe<Scalars['String']['input']>;
  interiorReadingLightsSeat2?: InputMaybe<Scalars['String']['input']>;
  interiorRearLuggageLight?: InputMaybe<Scalars['String']['input']>;
  interiorRemoteEngineStart?: InputMaybe<Scalars['String']['input']>;
  interiorSeatModelDocumentStorageCompartment?: InputMaybe<Scalars['String']['input']>;
  interiorSeatModelFrontCanAdjusted?: InputMaybe<Scalars['String']['input']>;
  interiorSeatModelMaterial?: InputMaybe<Scalars['String']['input']>;
  interiorSeatModelSeat2?: InputMaybe<Scalars['String']['input']>;
  interiorSeatModelSeat3?: InputMaybe<Scalars['String']['input']>;
  interiorSteeringWheel?: InputMaybe<Scalars['String']['input']>;
  interiorSteeringWheelMaterial?: InputMaybe<Scalars['String']['input']>;
  interiorSunshade?: InputMaybe<Scalars['String']['input']>;
  interiorTelephoneConnection?: InputMaybe<Scalars['String']['input']>;
  interiorUsbOrAuxDevice?: InputMaybe<Scalars['String']['input']>;
  interior_color?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  safety3rdBrakeLight?: InputMaybe<Scalars['String']['input']>;
  safety8PointsParkingSensors?: InputMaybe<Scalars['String']['input']>;
  safety360Camera?: InputMaybe<Scalars['String']['input']>;
  safetyAbsWithEbdAndBa?: InputMaybe<Scalars['String']['input']>;
  safetyAeb?: InputMaybe<Scalars['String']['input']>;
  safetyAhb?: InputMaybe<Scalars['String']['input']>;
  safetyAlarmForgetKey?: InputMaybe<Scalars['String']['input']>;
  safetyAntiTheftAlarm?: InputMaybe<Scalars['String']['input']>;
  safetyAttensionAssist?: InputMaybe<Scalars['String']['input']>;
  safetyBrakeOverrideSystem?: InputMaybe<Scalars['String']['input']>;
  safetyBsm?: InputMaybe<Scalars['String']['input']>;
  safetyCollapsibleBrakePedal?: InputMaybe<Scalars['String']['input']>;
  safetyDoorUnlockOnSrsAirbag?: InputMaybe<Scalars['String']['input']>;
  safetyElectricHandBrake?: InputMaybe<Scalars['String']['input']>;
  safetyElk?: InputMaybe<Scalars['String']['input']>;
  safetyEsc?: InputMaybe<Scalars['String']['input']>;
  safetyEssEmergencySignalSystem?: InputMaybe<Scalars['String']['input']>;
  safetyFcw?: InputMaybe<Scalars['String']['input']>;
  safetyFrontSeatBelt?: InputMaybe<Scalars['String']['input']>;
  safetyFrontSideAirbags?: InputMaybe<Scalars['String']['input']>;
  safetyHdc?: InputMaybe<Scalars['String']['input']>;
  safetyHsa?: InputMaybe<Scalars['String']['input']>;
  safetyIsofixMountingPoints?: InputMaybe<Scalars['String']['input']>;
  safetyLdp?: InputMaybe<Scalars['String']['input']>;
  safetyLdw?: InputMaybe<Scalars['String']['input']>;
  safetyLedDaytimeRunningLight?: InputMaybe<Scalars['String']['input']>;
  safetyLedTurningSignal?: InputMaybe<Scalars['String']['input']>;
  safetyLkas?: InputMaybe<Scalars['String']['input']>;
  safetyMcb?: InputMaybe<Scalars['String']['input']>;
  safetyMsl?: InputMaybe<Scalars['String']['input']>;
  safetyOneMotionUnlock?: InputMaybe<Scalars['String']['input']>;
  safetyPmm?: InputMaybe<Scalars['String']['input']>;
  safetyRcta?: InputMaybe<Scalars['String']['input']>;
  safetyRctaRctb?: InputMaybe<Scalars['String']['input']>;
  safetyRctb?: InputMaybe<Scalars['String']['input']>;
  safetyRearViewCamera?: InputMaybe<Scalars['String']['input']>;
  safetyRearViewMirrorWithAntiGlare?: InputMaybe<Scalars['String']['input']>;
  safetyRearWindowDefogger?: InputMaybe<Scalars['String']['input']>;
  safetySeatBelt2?: InputMaybe<Scalars['String']['input']>;
  safetySeatBelt3?: InputMaybe<Scalars['String']['input']>;
  safetySeatBeltReminder?: InputMaybe<Scalars['String']['input']>;
  safetySideAirbags?: InputMaybe<Scalars['String']['input']>;
  safetySideCurtainAirbags?: InputMaybe<Scalars['String']['input']>;
  safetySteelBeamDoor?: InputMaybe<Scalars['String']['input']>;
  safetyTcs?: InputMaybe<Scalars['String']['input']>;
  safetyTja?: InputMaybe<Scalars['String']['input']>;
  safetyTsc?: InputMaybe<Scalars['String']['input']>;
  safetyTurnAssist?: InputMaybe<Scalars['String']['input']>;
  safetyTurningSignalLights?: InputMaybe<Scalars['String']['input']>;
  safetyWalkAwayAutoDoorLock?: InputMaybe<Scalars['String']['input']>;
  safetyWarningTurnOffHeadlights?: InputMaybe<Scalars['String']['input']>;
  steeringMinTurningRadius?: InputMaybe<Scalars['String']['input']>;
  steeringType?: InputMaybe<Scalars['String']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  subCategory?: InputMaybe<Scalars['ID']['input']>;
  summary360Camera?: InputMaybe<Scalars['String']['input']>;
  summaryAudioSystem?: InputMaybe<Scalars['String']['input']>;
  summaryEngine?: InputMaybe<Scalars['String']['input']>;
  summaryMaxTorque?: InputMaybe<Scalars['String']['input']>;
  summaryRearViewCamera?: InputMaybe<Scalars['String']['input']>;
  summarySeatMaterial?: InputMaybe<Scalars['String']['input']>;
  summaryWheel?: InputMaybe<Scalars['String']['input']>;
  suspensionFront?: InputMaybe<Scalars['String']['input']>;
  suspensionRear?: InputMaybe<Scalars['String']['input']>;
  tailgateLockKey?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transmissionClutch?: InputMaybe<Scalars['String']['input']>;
  transmissionDifferentialGearLock?: InputMaybe<Scalars['String']['input']>;
  transmissionDriveSystem?: InputMaybe<Scalars['String']['input']>;
  transmissionFinalGearRatio?: InputMaybe<Scalars['String']['input']>;
  transmissionGear1?: InputMaybe<Scalars['String']['input']>;
  transmissionGear2?: InputMaybe<Scalars['String']['input']>;
  transmissionGear3?: InputMaybe<Scalars['String']['input']>;
  transmissionGear4?: InputMaybe<Scalars['String']['input']>;
  transmissionGear5?: InputMaybe<Scalars['String']['input']>;
  transmissionGear6?: InputMaybe<Scalars['String']['input']>;
  transmissionGear7?: InputMaybe<Scalars['String']['input']>;
  transmissionGear8?: InputMaybe<Scalars['String']['input']>;
  transmissionReverseGear?: InputMaybe<Scalars['String']['input']>;
  transmissionRoughTerrainMode?: InputMaybe<Scalars['String']['input']>;
  transmissionTransferGearRatio?: InputMaybe<Scalars['String']['input']>;
  transmissionType?: InputMaybe<Scalars['String']['input']>;
  wheel?: InputMaybe<Scalars['String']['input']>;
  wheelSpareTire?: InputMaybe<Scalars['String']['input']>;
  wheelTireSize?: InputMaybe<Scalars['String']['input']>;
};

export type LcvModelRelationResponseCollection = {
  nodes: Array<LcvModel>;
};

export type LcvModelSubCategory = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  lcv_models: Array<Maybe<LcvModel>>;
  lcv_models_connection?: Maybe<LcvModelRelationResponseCollection>;
  nameEn: Scalars['String']['output'];
  nameTh: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LcvModelSubCategoryLcv_ModelsArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvModelSubCategoryLcv_Models_ConnectionArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvModelSubCategoryEntityResponseCollection = {
  nodes: Array<LcvModelSubCategory>;
  pageInfo: Pagination;
};

export type LcvModelSubCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvModelSubCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lcv_models?: InputMaybe<LcvModelFiltersInput>;
  nameEn?: InputMaybe<StringFilterInput>;
  nameTh?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvModelSubCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvModelSubCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LcvModelSubCategoryInput = {
  lcv_models?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  nameEn?: InputMaybe<Scalars['String']['input']>;
  nameTh?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LcvNewsCategory = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  lcv_news_details: Array<Maybe<LcvNewsDetail>>;
  lcv_news_details_connection?: Maybe<LcvNewsDetailRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type LcvNewsCategoryLcv_News_DetailsArgs = {
  filters?: InputMaybe<LcvNewsDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvNewsCategoryLcv_News_Details_ConnectionArgs = {
  filters?: InputMaybe<LcvNewsDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvNewsCategoryEntityResponseCollection = {
  nodes: Array<LcvNewsCategory>;
  pageInfo: Pagination;
};

export type LcvNewsCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvNewsCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  lcv_news_details?: InputMaybe<LcvNewsDetailFiltersInput>;
  not?: InputMaybe<LcvNewsCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvNewsCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type LcvNewsCategoryInput = {
  lcv_news_details?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LcvNewsConfig = {
  category?: Maybe<Array<Maybe<ComponentNewsNewsPinnedByCategory>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  pinnedNews?: Maybe<LcvNewsDetail>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LcvNewsConfigCategoryArgs = {
  filters?: InputMaybe<ComponentNewsNewsPinnedByCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvNewsConfigInput = {
  category?: InputMaybe<Array<InputMaybe<ComponentNewsNewsPinnedByCategoryInput>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pinnedNews?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LcvNewsDetail = {
  active: Scalars['Boolean']['output'];
  beginDate: Scalars['Date']['output'];
  buttons?: Maybe<Array<Maybe<ComponentSharedButton>>>;
  category?: Maybe<LcvNewsCategory>;
  contentRows?: Maybe<Array<Maybe<LcvNewsDetailContentRowsDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  endDate: Scalars['Date']['output'];
  excerpt?: Maybe<ComponentNewsTextContent>;
  gallery: Array<Maybe<UploadFile>>;
  galleryTitle?: Maybe<Scalars['String']['output']>;
  gallery_connection?: Maybe<UploadFileRelationResponseCollection>;
  heroImage?: Maybe<UploadFile>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  thumbnail: UploadFile;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type LcvNewsDetailButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvNewsDetailGalleryArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvNewsDetailGallery_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvNewsDetailContentRowsDynamicZone = ComponentNewsHeader | ComponentNewsHighlighted | ComponentNewsImages | ComponentNewsSingleImage | ComponentNewsTextContent | ComponentNewsYoutube | Error;

export type LcvNewsDetailEntityResponseCollection = {
  nodes: Array<LcvNewsDetail>;
  pageInfo: Pagination;
};

export type LcvNewsDetailFiltersInput = {
  active?: InputMaybe<BooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<LcvNewsDetailFiltersInput>>>;
  beginDate?: InputMaybe<DateFilterInput>;
  buttons?: InputMaybe<ComponentSharedButtonFiltersInput>;
  category?: InputMaybe<LcvNewsCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  excerpt?: InputMaybe<ComponentNewsTextContentFiltersInput>;
  galleryTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvNewsDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvNewsDetailFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type LcvNewsDetailInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<ComponentSharedButtonInput>>>;
  category?: InputMaybe<Scalars['ID']['input']>;
  contentRows?: InputMaybe<Array<Scalars['LcvNewsDetailContentRowsDynamicZoneInput']['input']>>;
  draftOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excerpt?: InputMaybe<ComponentNewsTextContentInput>;
  gallery?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  galleryTitle?: InputMaybe<Scalars['String']['input']>;
  heroImage?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LcvNewsDetailRelationResponseCollection = {
  nodes: Array<LcvNewsDetail>;
};

export type LcvOffer = {
  beginDate: Scalars['Date']['output'];
  buttons?: Maybe<Array<Maybe<ComponentSharedButtonWithIcons>>>;
  category: LcvOfferCategory;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  detailImage: UploadFile;
  documentId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  isActive: Scalars['Boolean']['output'];
  model?: Maybe<Enum_Lcvoffer_Model>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  seo: ComponentSharedMeta;
  showFormRegister?: Maybe<Scalars['Boolean']['output']>;
  showInListPage: Scalars['Boolean']['output'];
  showInSpecialCampaigns: Scalars['Boolean']['output'];
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  thumbnailImage: UploadFile;
  title: Scalars['String']['output'];
  type?: Maybe<Enum_Lcvoffer_Type>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type LcvOfferButtonsArgs = {
  filters?: InputMaybe<ComponentSharedButtonWithIconsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvOfferCategory = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  offers: Array<Maybe<LcvOffer>>;
  offers_connection?: Maybe<LcvOfferRelationResponseCollection>;
  pinned?: Maybe<LcvOffer>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type LcvOfferCategoryOffersArgs = {
  filters?: InputMaybe<LcvOfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvOfferCategoryOffers_ConnectionArgs = {
  filters?: InputMaybe<LcvOfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvOfferCategoryEntityResponseCollection = {
  nodes: Array<LcvOfferCategory>;
  pageInfo: Pagination;
};

export type LcvOfferCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvOfferCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvOfferCategoryFiltersInput>;
  offers?: InputMaybe<LcvOfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvOfferCategoryFiltersInput>>>;
  pinned?: InputMaybe<LcvOfferFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type LcvOfferCategoryInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pinned?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LcvOfferCategoryRelationResponseCollection = {
  nodes: Array<LcvOfferCategory>;
};

export type LcvOfferConfig = {
  categoryOrder: Array<Maybe<LcvOfferCategory>>;
  categoryOrder_connection?: Maybe<LcvOfferCategoryRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  pinnedOffers: Array<Maybe<LcvOffer>>;
  pinnedOffers_connection?: Maybe<LcvOfferRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  showFinanceCategory: Scalars['Boolean']['output'];
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LcvOfferConfigCategoryOrderArgs = {
  filters?: InputMaybe<LcvOfferCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvOfferConfigCategoryOrder_ConnectionArgs = {
  filters?: InputMaybe<LcvOfferCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvOfferConfigPinnedOffersArgs = {
  filters?: InputMaybe<LcvOfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvOfferConfigPinnedOffers_ConnectionArgs = {
  filters?: InputMaybe<LcvOfferFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvOfferConfigInput = {
  categoryOrder?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  pinnedOffers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  showFinanceCategory?: InputMaybe<Scalars['Boolean']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type LcvOfferEntityResponseCollection = {
  nodes: Array<LcvOffer>;
  pageInfo: Pagination;
};

export type LcvOfferFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvOfferFiltersInput>>>;
  beginDate?: InputMaybe<DateFilterInput>;
  buttons?: InputMaybe<ComponentSharedButtonWithIconsFiltersInput>;
  category?: InputMaybe<LcvOfferCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  detail?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  model?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvOfferFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvOfferFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  remark?: InputMaybe<StringFilterInput>;
  seo?: InputMaybe<ComponentSharedMetaFiltersInput>;
  showFormRegister?: InputMaybe<BooleanFilterInput>;
  showInListPage?: InputMaybe<BooleanFilterInput>;
  showInSpecialCampaigns?: InputMaybe<BooleanFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type LcvOfferInput = {
  beginDate?: InputMaybe<Scalars['Date']['input']>;
  buttons?: InputMaybe<Array<InputMaybe<ComponentSharedButtonWithIconsInput>>>;
  category?: InputMaybe<Scalars['ID']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<Scalars['ID']['input']>;
  draftOnly?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Enum_Lcvoffer_Model>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<ComponentSharedMetaInput>;
  showFormRegister?: InputMaybe<Scalars['Boolean']['input']>;
  showInListPage?: InputMaybe<Scalars['Boolean']['input']>;
  showInSpecialCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  thumbnailImage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Lcvoffer_Type>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LcvOfferRelationResponseCollection = {
  nodes: Array<LcvOffer>;
};

export type LcvPartConfig = {
  categories?: Maybe<Array<Maybe<ComponentServicesPartCategoryItem>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleType: ComponentSharedVehicleType;
};


export type LcvPartConfigCategoriesArgs = {
  filters?: InputMaybe<ComponentServicesPartCategoryItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvPartConfigInput = {
  categories?: InputMaybe<Array<InputMaybe<ComponentServicesPartCategoryItemInput>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<ComponentSharedVehicleTypeInput>;
};

export type LcvServiceCampaign = {
  beginDate: Scalars['DateTime']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  detailImage: UploadFile;
  documentId: Scalars['ID']['output'];
  endDate: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  isDetailAndThumbnailSameImage?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  seo: ComponentSharedMeta;
  showAppointmentCta?: Maybe<Scalars['Boolean']['output']>;
  showInListPage?: Maybe<Scalars['Boolean']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  tabDetails: Array<Maybe<LcvServiceCampaignTabDetail>>;
  tabDetails_connection?: Maybe<LcvServiceCampaignTabDetailRelationResponseCollection>;
  thumbnailImage: UploadFile;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type LcvServiceCampaignTabDetailsArgs = {
  filters?: InputMaybe<LcvServiceCampaignTabDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvServiceCampaignTabDetails_ConnectionArgs = {
  filters?: InputMaybe<LcvServiceCampaignTabDetailFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvServiceCampaignEntityResponseCollection = {
  nodes: Array<LcvServiceCampaign>;
  pageInfo: Pagination;
};

export type LcvServiceCampaignFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvServiceCampaignFiltersInput>>>;
  beginDate?: InputMaybe<DateTimeFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  endDate?: InputMaybe<DateTimeFilterInput>;
  isActive?: InputMaybe<BooleanFilterInput>;
  isDetailAndThumbnailSameImage?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<LcvServiceCampaignFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvServiceCampaignFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  remark?: InputMaybe<StringFilterInput>;
  seo?: InputMaybe<ComponentSharedMetaFiltersInput>;
  showAppointmentCta?: InputMaybe<BooleanFilterInput>;
  showInListPage?: InputMaybe<BooleanFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  tabDetails?: InputMaybe<LcvServiceCampaignTabDetailFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type LcvServiceCampaignInput = {
  beginDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDetailAndThumbnailSameImage?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<ComponentSharedMetaInput>;
  showAppointmentCta?: InputMaybe<Scalars['Boolean']['input']>;
  showInListPage?: InputMaybe<Scalars['Boolean']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  tabDetails?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  thumbnailImage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LcvServiceCampaignRelationResponseCollection = {
  nodes: Array<LcvServiceCampaign>;
};

export type LcvServiceCampaignTabDetail = {
  contentRows?: Maybe<Array<Maybe<LcvServiceCampaignTabDetailContentRowsDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  serviceCampaign?: Maybe<LcvServiceCampaign>;
  slug: Scalars['String']['output'];
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LcvServiceCampaignTabDetailContentRowsDynamicZone = ComponentSharedComponentAccordion | ComponentSharedComponentDescription | ComponentSharedComponentHeader | ComponentSharedComponentHighlightCardGroup | ComponentSharedComponentHtmlTable | ComponentSharedComponentImageCardHorizontal | ComponentSharedComponentImageCardVertical | ComponentSharedComponentImageWithCta | ComponentSharedComponentMyMemberTable | ComponentSharedComponentResponsiveTable | ComponentSharedComponentTextCardGroup | ComponentSharedComponentTwoColumnsTable | ComponentSharedComponentYoutube | Error;

export type LcvServiceCampaignTabDetailEntityResponseCollection = {
  nodes: Array<LcvServiceCampaignTabDetail>;
  pageInfo: Pagination;
};

export type LcvServiceCampaignTabDetailFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<LcvServiceCampaignTabDetailFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LcvServiceCampaignTabDetailFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LcvServiceCampaignTabDetailFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  serviceCampaign?: InputMaybe<LcvServiceCampaignFiltersInput>;
  slug?: InputMaybe<StringFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type LcvServiceCampaignTabDetailInput = {
  contentRows?: InputMaybe<Array<Scalars['LcvServiceCampaignTabDetailContentRowsDynamicZoneInput']['input']>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  serviceCampaign?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type LcvServiceCampaignTabDetailRelationResponseCollection = {
  nodes: Array<LcvServiceCampaignTabDetail>;
};

export type LcvServiceSpecialOfferConfig = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  pinnedOffers: Array<Maybe<LcvServiceCampaign>>;
  pinnedOffers_connection?: Maybe<LcvServiceCampaignRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type LcvServiceSpecialOfferConfigPinnedOffersArgs = {
  filters?: InputMaybe<LcvServiceCampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LcvServiceSpecialOfferConfigPinnedOffers_ConnectionArgs = {
  filters?: InputMaybe<LcvServiceCampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LcvServiceSpecialOfferConfigInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  pinnedOffers?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type LcvSpecialCampaign = {
  active?: Maybe<Scalars['Boolean']['output']>;
  begineDate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  showInCalculator?: Maybe<Scalars['Boolean']['output']>;
  showInProduct?: Maybe<Scalars['Boolean']['output']>;
  showInRegister?: Maybe<Scalars['Boolean']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LcvSpecialCampaignInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  begineDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  showInCalculator?: InputMaybe<Scalars['Boolean']['input']>;
  showInProduct?: InputMaybe<Scalars['Boolean']['input']>;
  showInRegister?: InputMaybe<Scalars['Boolean']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createCvBodyType?: Maybe<CvBodyType>;
  createCvBusinessType?: Maybe<CvBusinessType>;
  createCvContentHubCategory?: Maybe<CvContentHubCategory>;
  createCvContentHubContent?: Maybe<CvContentHubContent>;
  createCvContentHubTag?: Maybe<CvContentHubTag>;
  createCvMaintenance?: Maybe<CvMaintenance>;
  createCvModel?: Maybe<CvModel>;
  createCvModelCategory?: Maybe<CvModelCategory>;
  createCvModelClass?: Maybe<CvModelClass>;
  createCvModelSubCategory?: Maybe<CvModelSubCategory>;
  createCvOffer?: Maybe<CvOffer>;
  createCvOfferCategory?: Maybe<CvOfferCategory>;
  createCvSegmentType?: Maybe<CvSegmentType>;
  createCvServiceCampaign?: Maybe<CvServiceCampaign>;
  createCvServiceCampaignTabDetail?: Maybe<CvServiceCampaignTabDetail>;
  createLcvColor?: Maybe<LcvColor>;
  createLcvContentHubCategory?: Maybe<LcvContentHubCategory>;
  createLcvContentHubContent?: Maybe<LcvContentHubContent>;
  createLcvContentHubTag?: Maybe<LcvContentHubTag>;
  createLcvInteriorColor?: Maybe<LcvInteriorColor>;
  createLcvMaintenance?: Maybe<LcvMaintenance>;
  createLcvModel?: Maybe<LcvModel>;
  createLcvModelCategory?: Maybe<LcvModelCategory>;
  createLcvModelColor?: Maybe<LcvModelColor>;
  createLcvModelSubCategory?: Maybe<LcvModelSubCategory>;
  createLcvNewsCategory?: Maybe<LcvNewsCategory>;
  createLcvNewsDetail?: Maybe<LcvNewsDetail>;
  createLcvOffer?: Maybe<LcvOffer>;
  createLcvOfferCategory?: Maybe<LcvOfferCategory>;
  createLcvServiceCampaign?: Maybe<LcvServiceCampaign>;
  createLcvServiceCampaignTabDetail?: Maybe<LcvServiceCampaignTabDetail>;
  createPartCategory?: Maybe<PartCategory>;
  createPartItem?: Maybe<PartItem>;
  createQuestionItem?: Maybe<QuestionItem>;
  createReferralProgram?: Maybe<ReferralProgram>;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteCvBodyType?: Maybe<DeleteMutationResponse>;
  deleteCvBusinessType?: Maybe<DeleteMutationResponse>;
  deleteCvContentHubCategory?: Maybe<DeleteMutationResponse>;
  deleteCvContentHubConfig?: Maybe<DeleteMutationResponse>;
  deleteCvContentHubContent?: Maybe<DeleteMutationResponse>;
  deleteCvContentHubTag?: Maybe<DeleteMutationResponse>;
  deleteCvHomepage?: Maybe<DeleteMutationResponse>;
  deleteCvMaintenance?: Maybe<DeleteMutationResponse>;
  deleteCvMaintenanceConfig?: Maybe<DeleteMutationResponse>;
  deleteCvModel?: Maybe<DeleteMutationResponse>;
  deleteCvModelCategory?: Maybe<DeleteMutationResponse>;
  deleteCvModelClass?: Maybe<DeleteMutationResponse>;
  deleteCvModelConfig?: Maybe<DeleteMutationResponse>;
  deleteCvModelSubCategory?: Maybe<DeleteMutationResponse>;
  deleteCvOffer?: Maybe<DeleteMutationResponse>;
  deleteCvOfferCategory?: Maybe<DeleteMutationResponse>;
  deleteCvOfferConfig?: Maybe<DeleteMutationResponse>;
  deleteCvPartConfig?: Maybe<DeleteMutationResponse>;
  deleteCvSegmentType?: Maybe<DeleteMutationResponse>;
  deleteCvServiceCampaign?: Maybe<DeleteMutationResponse>;
  deleteCvServiceCampaignTabDetail?: Maybe<DeleteMutationResponse>;
  deleteCvServiceHomeConfig?: Maybe<DeleteMutationResponse>;
  deleteCvServiceSpecialOfferConfig?: Maybe<DeleteMutationResponse>;
  deleteLcvColor?: Maybe<DeleteMutationResponse>;
  deleteLcvContentHubCategory?: Maybe<DeleteMutationResponse>;
  deleteLcvContentHubConfig?: Maybe<DeleteMutationResponse>;
  deleteLcvContentHubContent?: Maybe<DeleteMutationResponse>;
  deleteLcvContentHubTag?: Maybe<DeleteMutationResponse>;
  deleteLcvHomepage?: Maybe<DeleteMutationResponse>;
  deleteLcvInteriorColor?: Maybe<DeleteMutationResponse>;
  deleteLcvMaintenance?: Maybe<DeleteMutationResponse>;
  deleteLcvMaintenanceConfig?: Maybe<DeleteMutationResponse>;
  deleteLcvModel?: Maybe<DeleteMutationResponse>;
  deleteLcvModelCategory?: Maybe<DeleteMutationResponse>;
  deleteLcvModelColor?: Maybe<DeleteMutationResponse>;
  deleteLcvModelConfig?: Maybe<DeleteMutationResponse>;
  deleteLcvModelSubCategory?: Maybe<DeleteMutationResponse>;
  deleteLcvNewsCategory?: Maybe<DeleteMutationResponse>;
  deleteLcvNewsConfig?: Maybe<DeleteMutationResponse>;
  deleteLcvNewsDetail?: Maybe<DeleteMutationResponse>;
  deleteLcvOffer?: Maybe<DeleteMutationResponse>;
  deleteLcvOfferCategory?: Maybe<DeleteMutationResponse>;
  deleteLcvOfferConfig?: Maybe<DeleteMutationResponse>;
  deleteLcvPartConfig?: Maybe<DeleteMutationResponse>;
  deleteLcvServiceCampaign?: Maybe<DeleteMutationResponse>;
  deleteLcvServiceCampaignTabDetail?: Maybe<DeleteMutationResponse>;
  deleteLcvServiceSpecialOfferConfig?: Maybe<DeleteMutationResponse>;
  deleteLcvSpecialCampaign?: Maybe<DeleteMutationResponse>;
  deleteOmoCvModelConfig?: Maybe<DeleteMutationResponse>;
  deleteOmoLcvModelConfig?: Maybe<DeleteMutationResponse>;
  deletePartCategory?: Maybe<DeleteMutationResponse>;
  deletePartItem?: Maybe<DeleteMutationResponse>;
  deleteQuestionItem?: Maybe<DeleteMutationResponse>;
  deleteReferralProgram?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteSurveyCsiConfig?: Maybe<DeleteMutationResponse>;
  deleteSurveySsiConfig?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateCvBodyType?: Maybe<CvBodyType>;
  updateCvBusinessType?: Maybe<CvBusinessType>;
  updateCvContentHubCategory?: Maybe<CvContentHubCategory>;
  updateCvContentHubConfig?: Maybe<CvContentHubConfig>;
  updateCvContentHubContent?: Maybe<CvContentHubContent>;
  updateCvContentHubTag?: Maybe<CvContentHubTag>;
  updateCvHomepage?: Maybe<CvHomepage>;
  updateCvMaintenance?: Maybe<CvMaintenance>;
  updateCvMaintenanceConfig?: Maybe<CvMaintenanceConfig>;
  updateCvModel?: Maybe<CvModel>;
  updateCvModelCategory?: Maybe<CvModelCategory>;
  updateCvModelClass?: Maybe<CvModelClass>;
  updateCvModelConfig?: Maybe<CvModelConfig>;
  updateCvModelSubCategory?: Maybe<CvModelSubCategory>;
  updateCvOffer?: Maybe<CvOffer>;
  updateCvOfferCategory?: Maybe<CvOfferCategory>;
  updateCvOfferConfig?: Maybe<CvOfferConfig>;
  updateCvPartConfig?: Maybe<CvPartConfig>;
  updateCvSegmentType?: Maybe<CvSegmentType>;
  updateCvServiceCampaign?: Maybe<CvServiceCampaign>;
  updateCvServiceCampaignTabDetail?: Maybe<CvServiceCampaignTabDetail>;
  updateCvServiceHomeConfig?: Maybe<CvServiceHomeConfig>;
  updateCvServiceSpecialOfferConfig?: Maybe<CvServiceSpecialOfferConfig>;
  updateLcvColor?: Maybe<LcvColor>;
  updateLcvContentHubCategory?: Maybe<LcvContentHubCategory>;
  updateLcvContentHubConfig?: Maybe<LcvContentHubConfig>;
  updateLcvContentHubContent?: Maybe<LcvContentHubContent>;
  updateLcvContentHubTag?: Maybe<LcvContentHubTag>;
  updateLcvHomepage?: Maybe<LcvHomepage>;
  updateLcvInteriorColor?: Maybe<LcvInteriorColor>;
  updateLcvMaintenance?: Maybe<LcvMaintenance>;
  updateLcvMaintenanceConfig?: Maybe<LcvMaintenanceConfig>;
  updateLcvModel?: Maybe<LcvModel>;
  updateLcvModelCategory?: Maybe<LcvModelCategory>;
  updateLcvModelColor?: Maybe<LcvModelColor>;
  updateLcvModelConfig?: Maybe<LcvModelConfig>;
  updateLcvModelSubCategory?: Maybe<LcvModelSubCategory>;
  updateLcvNewsCategory?: Maybe<LcvNewsCategory>;
  updateLcvNewsConfig?: Maybe<LcvNewsConfig>;
  updateLcvNewsDetail?: Maybe<LcvNewsDetail>;
  updateLcvOffer?: Maybe<LcvOffer>;
  updateLcvOfferCategory?: Maybe<LcvOfferCategory>;
  updateLcvOfferConfig?: Maybe<LcvOfferConfig>;
  updateLcvPartConfig?: Maybe<LcvPartConfig>;
  updateLcvServiceCampaign?: Maybe<LcvServiceCampaign>;
  updateLcvServiceCampaignTabDetail?: Maybe<LcvServiceCampaignTabDetail>;
  updateLcvServiceSpecialOfferConfig?: Maybe<LcvServiceSpecialOfferConfig>;
  updateLcvSpecialCampaign?: Maybe<LcvSpecialCampaign>;
  updateOmoCvModelConfig?: Maybe<OmoCvModelConfig>;
  updateOmoLcvModelConfig?: Maybe<OmoLcvModelConfig>;
  updatePartCategory?: Maybe<PartCategory>;
  updatePartItem?: Maybe<PartItem>;
  updateQuestionItem?: Maybe<QuestionItem>;
  updateReferralProgram?: Maybe<ReferralProgram>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateSurveyCsiConfig?: Maybe<SurveyCsiConfig>;
  updateSurveySsiConfig?: Maybe<SurveySsiConfig>;
  updateUploadFile: UploadFile;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateCvBodyTypeArgs = {
  data: CvBodyTypeInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvBusinessTypeArgs = {
  data: CvBusinessTypeInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvContentHubCategoryArgs = {
  data: CvContentHubCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvContentHubContentArgs = {
  data: CvContentHubContentInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvContentHubTagArgs = {
  data: CvContentHubTagInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvMaintenanceArgs = {
  data: CvMaintenanceInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvModelArgs = {
  data: CvModelInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvModelCategoryArgs = {
  data: CvModelCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvModelClassArgs = {
  data: CvModelClassInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvModelSubCategoryArgs = {
  data: CvModelSubCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvOfferArgs = {
  data: CvOfferInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvOfferCategoryArgs = {
  data: CvOfferCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvSegmentTypeArgs = {
  data: CvSegmentTypeInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvServiceCampaignArgs = {
  data: CvServiceCampaignInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateCvServiceCampaignTabDetailArgs = {
  data: CvServiceCampaignTabDetailInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvColorArgs = {
  data: LcvColorInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvContentHubCategoryArgs = {
  data: LcvContentHubCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvContentHubContentArgs = {
  data: LcvContentHubContentInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvContentHubTagArgs = {
  data: LcvContentHubTagInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvInteriorColorArgs = {
  data: LcvInteriorColorInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvMaintenanceArgs = {
  data: LcvMaintenanceInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvModelArgs = {
  data: LcvModelInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvModelCategoryArgs = {
  data: LcvModelCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvModelColorArgs = {
  data: LcvModelColorInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvModelSubCategoryArgs = {
  data: LcvModelSubCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvNewsCategoryArgs = {
  data: LcvNewsCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvNewsDetailArgs = {
  data: LcvNewsDetailInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvOfferArgs = {
  data: LcvOfferInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvOfferCategoryArgs = {
  data: LcvOfferCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvServiceCampaignArgs = {
  data: LcvServiceCampaignInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateLcvServiceCampaignTabDetailArgs = {
  data: LcvServiceCampaignTabDetailInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreatePartCategoryArgs = {
  data: PartCategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreatePartItemArgs = {
  data: PartItemInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateQuestionItemArgs = {
  data: QuestionItemInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReferralProgramArgs = {
  data: ReferralProgramInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteCvBodyTypeArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvBusinessTypeArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvContentHubCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvContentHubContentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvContentHubTagArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvMaintenanceArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvModelArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvModelCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvModelClassArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvModelSubCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvOfferArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvOfferCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvSegmentTypeArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvServiceCampaignArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCvServiceCampaignTabDetailArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvColorArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvContentHubCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvContentHubContentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvContentHubTagArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvInteriorColorArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvMaintenanceArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvModelArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvModelCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvModelColorArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvModelSubCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvNewsCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvNewsDetailArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvOfferArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvOfferCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvServiceCampaignArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteLcvServiceCampaignTabDetailArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeletePartCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeletePartItemArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteQuestionItemArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReferralProgramArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateCvBodyTypeArgs = {
  data: CvBodyTypeInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvBusinessTypeArgs = {
  data: CvBusinessTypeInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvContentHubCategoryArgs = {
  data: CvContentHubCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvContentHubConfigArgs = {
  data: CvContentHubConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvContentHubContentArgs = {
  data: CvContentHubContentInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvContentHubTagArgs = {
  data: CvContentHubTagInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvHomepageArgs = {
  data: CvHomepageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvMaintenanceArgs = {
  data: CvMaintenanceInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvMaintenanceConfigArgs = {
  data: CvMaintenanceConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvModelArgs = {
  data: CvModelInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvModelCategoryArgs = {
  data: CvModelCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvModelClassArgs = {
  data: CvModelClassInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvModelConfigArgs = {
  data: CvModelConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvModelSubCategoryArgs = {
  data: CvModelSubCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvOfferArgs = {
  data: CvOfferInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvOfferCategoryArgs = {
  data: CvOfferCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvOfferConfigArgs = {
  data: CvOfferConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvPartConfigArgs = {
  data: CvPartConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvSegmentTypeArgs = {
  data: CvSegmentTypeInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvServiceCampaignArgs = {
  data: CvServiceCampaignInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvServiceCampaignTabDetailArgs = {
  data: CvServiceCampaignTabDetailInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvServiceHomeConfigArgs = {
  data: CvServiceHomeConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCvServiceSpecialOfferConfigArgs = {
  data: CvServiceSpecialOfferConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvColorArgs = {
  data: LcvColorInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvContentHubCategoryArgs = {
  data: LcvContentHubCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvContentHubConfigArgs = {
  data: LcvContentHubConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvContentHubContentArgs = {
  data: LcvContentHubContentInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvContentHubTagArgs = {
  data: LcvContentHubTagInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvHomepageArgs = {
  data: LcvHomepageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvInteriorColorArgs = {
  data: LcvInteriorColorInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvMaintenanceArgs = {
  data: LcvMaintenanceInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvMaintenanceConfigArgs = {
  data: LcvMaintenanceConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvModelArgs = {
  data: LcvModelInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvModelCategoryArgs = {
  data: LcvModelCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvModelColorArgs = {
  data: LcvModelColorInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvModelConfigArgs = {
  data: LcvModelConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvModelSubCategoryArgs = {
  data: LcvModelSubCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvNewsCategoryArgs = {
  data: LcvNewsCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvNewsConfigArgs = {
  data: LcvNewsConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvNewsDetailArgs = {
  data: LcvNewsDetailInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvOfferArgs = {
  data: LcvOfferInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvOfferCategoryArgs = {
  data: LcvOfferCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvOfferConfigArgs = {
  data: LcvOfferConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvPartConfigArgs = {
  data: LcvPartConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvServiceCampaignArgs = {
  data: LcvServiceCampaignInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvServiceCampaignTabDetailArgs = {
  data: LcvServiceCampaignTabDetailInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvServiceSpecialOfferConfigArgs = {
  data: LcvServiceSpecialOfferConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLcvSpecialCampaignArgs = {
  data: LcvSpecialCampaignInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateOmoCvModelConfigArgs = {
  data: OmoCvModelConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateOmoLcvModelConfigArgs = {
  data: OmoLcvModelConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdatePartCategoryArgs = {
  data: PartCategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdatePartItemArgs = {
  data: PartItemInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateQuestionItemArgs = {
  data: QuestionItemInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReferralProgramArgs = {
  data: ReferralProgramInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSurveyCsiConfigArgs = {
  data: SurveyCsiConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateSurveySsiConfigArgs = {
  data: SurveySsiConfigInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};

export type OmoCvModelConfig = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  subCategoryModelLineup?: Maybe<Array<Maybe<ComponentOmoCvOmoCategoryModelLineup>>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type OmoCvModelConfigSubCategoryModelLineupArgs = {
  filters?: InputMaybe<ComponentOmoCvOmoCategoryModelLineupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OmoCvModelConfigInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  subCategoryModelLineup?: InputMaybe<Array<InputMaybe<ComponentOmoCvOmoCategoryModelLineupInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type OmoLcvModelConfig = {
  categoryModelLineup?: Maybe<Array<Maybe<ComponentOmoLcvOmoModelCategoryLineup>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type OmoLcvModelConfigCategoryModelLineupArgs = {
  filters?: InputMaybe<ComponentOmoLcvOmoModelCategoryLineupFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OmoLcvModelConfigInput = {
  categoryModelLineup?: InputMaybe<Array<InputMaybe<ComponentOmoLcvOmoModelCategoryLineupInput>>>;
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Pagination = {
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type PartCategory = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  partItems: Array<Maybe<PartItem>>;
  partItems_connection?: Maybe<PartItemRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};


export type PartCategoryPartItemsArgs = {
  filters?: InputMaybe<PartItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type PartCategoryPartItems_ConnectionArgs = {
  filters?: InputMaybe<PartItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartCategoryEntityResponseCollection = {
  nodes: Array<PartCategory>;
  pageInfo: Pagination;
};

export type PartCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PartCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<PartCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<PartCategoryFiltersInput>>>;
  partItems?: InputMaybe<PartItemFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type PartCategoryInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  partItems?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type PartItem = {
  batteryTireContent?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  damages?: Maybe<Scalars['String']['output']>;
  damagesRemark?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  detailImage?: Maybe<UploadFile>;
  documentId: Scalars['ID']['output'];
  genuineParts?: Maybe<Array<Maybe<ComponentServicesGenuinePart>>>;
  hasSymptomsRemark?: Maybe<Scalars['Boolean']['output']>;
  headlineTitle: Scalars['String']['output'];
  isuzuSvcAdvantages?: Maybe<Scalars['String']['output']>;
  offerDescription?: Maybe<Scalars['String']['output']>;
  offerUrl?: Maybe<Scalars['String']['output']>;
  partCategory?: Maybe<PartCategory>;
  partFile?: Maybe<UploadFile>;
  partImage?: Maybe<UploadFile>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  replacementInterval?: Maybe<Scalars['String']['output']>;
  seo?: Maybe<ComponentSharedSeo>;
  showDealerButton?: Maybe<Scalars['Boolean']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  symptomsChecker?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  vehicleType: Enum_Partitem_Vehicletype;
  warrantyDescription?: Maybe<Scalars['String']['output']>;
  warrantyFile?: Maybe<UploadFile>;
  warrantyUrl?: Maybe<Scalars['String']['output']>;
};


export type PartItemGenuinePartsArgs = {
  filters?: InputMaybe<ComponentServicesGenuinePartFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PartItemEntityResponseCollection = {
  nodes: Array<PartItem>;
  pageInfo: Pagination;
};

export type PartItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<PartItemFiltersInput>>>;
  batteryTireContent?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  damages?: InputMaybe<StringFilterInput>;
  damagesRemark?: InputMaybe<StringFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  genuineParts?: InputMaybe<ComponentServicesGenuinePartFiltersInput>;
  hasSymptomsRemark?: InputMaybe<BooleanFilterInput>;
  headlineTitle?: InputMaybe<StringFilterInput>;
  isuzuSvcAdvantages?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PartItemFiltersInput>;
  offerDescription?: InputMaybe<StringFilterInput>;
  offerUrl?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<PartItemFiltersInput>>>;
  partCategory?: InputMaybe<PartCategoryFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  remark?: InputMaybe<StringFilterInput>;
  replacementInterval?: InputMaybe<StringFilterInput>;
  seo?: InputMaybe<ComponentSharedSeoFiltersInput>;
  showDealerButton?: InputMaybe<BooleanFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  symptomsChecker?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  vehicleType?: InputMaybe<StringFilterInput>;
  warrantyDescription?: InputMaybe<StringFilterInput>;
  warrantyUrl?: InputMaybe<StringFilterInput>;
};

export type PartItemInput = {
  batteryTireContent?: InputMaybe<Scalars['String']['input']>;
  damages?: InputMaybe<Scalars['String']['input']>;
  damagesRemark?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  detailImage?: InputMaybe<Scalars['ID']['input']>;
  genuineParts?: InputMaybe<Array<InputMaybe<ComponentServicesGenuinePartInput>>>;
  hasSymptomsRemark?: InputMaybe<Scalars['Boolean']['input']>;
  headlineTitle?: InputMaybe<Scalars['String']['input']>;
  isuzuSvcAdvantages?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  offerDescription?: InputMaybe<Scalars['String']['input']>;
  offerUrl?: InputMaybe<Scalars['String']['input']>;
  partCategory?: InputMaybe<Scalars['ID']['input']>;
  partFile?: InputMaybe<Scalars['ID']['input']>;
  partImage?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  replacementInterval?: InputMaybe<Scalars['String']['input']>;
  seo?: InputMaybe<ComponentSharedSeoInput>;
  showDealerButton?: InputMaybe<Scalars['Boolean']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  symptomsChecker?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<Enum_Partitem_Vehicletype>;
  warrantyDescription?: InputMaybe<Scalars['String']['input']>;
  warrantyFile?: InputMaybe<Scalars['ID']['input']>;
  warrantyUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PartItemRelationResponseCollection = {
  nodes: Array<PartItem>;
};

export enum PublicationFilter {
  HasPublishedVersion = 'HAS_PUBLISHED_VERSION',
  HasPublishedVersionDocument = 'HAS_PUBLISHED_VERSION_DOCUMENT',
  Modified = 'MODIFIED',
  NeverPublished = 'NEVER_PUBLISHED',
  NeverPublishedDocument = 'NEVER_PUBLISHED_DOCUMENT',
  PublishedWithoutDraft = 'PUBLISHED_WITHOUT_DRAFT',
  PublishedWithDraft = 'PUBLISHED_WITH_DRAFT',
  Unmodified = 'UNMODIFIED'
}

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type Query = {
  cvBodyType?: Maybe<CvBodyType>;
  cvBodyTypes: Array<Maybe<CvBodyType>>;
  cvBodyTypes_connection?: Maybe<CvBodyTypeEntityResponseCollection>;
  cvBusinessType?: Maybe<CvBusinessType>;
  cvBusinessTypes: Array<Maybe<CvBusinessType>>;
  cvBusinessTypes_connection?: Maybe<CvBusinessTypeEntityResponseCollection>;
  cvContentHubCategories: Array<Maybe<CvContentHubCategory>>;
  cvContentHubCategories_connection?: Maybe<CvContentHubCategoryEntityResponseCollection>;
  cvContentHubCategory?: Maybe<CvContentHubCategory>;
  cvContentHubConfig?: Maybe<CvContentHubConfig>;
  cvContentHubContent?: Maybe<CvContentHubContent>;
  cvContentHubContents: Array<Maybe<CvContentHubContent>>;
  cvContentHubContents_connection?: Maybe<CvContentHubContentEntityResponseCollection>;
  cvContentHubTag?: Maybe<CvContentHubTag>;
  cvContentHubTags: Array<Maybe<CvContentHubTag>>;
  cvContentHubTags_connection?: Maybe<CvContentHubTagEntityResponseCollection>;
  cvHomepage?: Maybe<CvHomepage>;
  cvMaintenance?: Maybe<CvMaintenance>;
  cvMaintenanceConfig?: Maybe<CvMaintenanceConfig>;
  cvMaintenances: Array<Maybe<CvMaintenance>>;
  cvMaintenances_connection?: Maybe<CvMaintenanceEntityResponseCollection>;
  cvModel?: Maybe<CvModel>;
  cvModelCategories: Array<Maybe<CvModelCategory>>;
  cvModelCategories_connection?: Maybe<CvModelCategoryEntityResponseCollection>;
  cvModelCategory?: Maybe<CvModelCategory>;
  cvModelClass?: Maybe<CvModelClass>;
  cvModelClasses: Array<Maybe<CvModelClass>>;
  cvModelClasses_connection?: Maybe<CvModelClassEntityResponseCollection>;
  cvModelConfig?: Maybe<CvModelConfig>;
  cvModelSubCategories: Array<Maybe<CvModelSubCategory>>;
  cvModelSubCategories_connection?: Maybe<CvModelSubCategoryEntityResponseCollection>;
  cvModelSubCategory?: Maybe<CvModelSubCategory>;
  cvModels: Array<Maybe<CvModel>>;
  cvModels_connection?: Maybe<CvModelEntityResponseCollection>;
  cvOffer?: Maybe<CvOffer>;
  cvOfferCategories: Array<Maybe<CvOfferCategory>>;
  cvOfferCategories_connection?: Maybe<CvOfferCategoryEntityResponseCollection>;
  cvOfferCategory?: Maybe<CvOfferCategory>;
  cvOfferConfig?: Maybe<CvOfferConfig>;
  cvOffers: Array<Maybe<CvOffer>>;
  cvOffers_connection?: Maybe<CvOfferEntityResponseCollection>;
  cvPartConfig?: Maybe<CvPartConfig>;
  cvSegmentType?: Maybe<CvSegmentType>;
  cvSegmentTypes: Array<Maybe<CvSegmentType>>;
  cvSegmentTypes_connection?: Maybe<CvSegmentTypeEntityResponseCollection>;
  cvServiceCampaign?: Maybe<CvServiceCampaign>;
  cvServiceCampaignTabDetail?: Maybe<CvServiceCampaignTabDetail>;
  cvServiceCampaignTabDetails: Array<Maybe<CvServiceCampaignTabDetail>>;
  cvServiceCampaignTabDetails_connection?: Maybe<CvServiceCampaignTabDetailEntityResponseCollection>;
  cvServiceCampaigns: Array<Maybe<CvServiceCampaign>>;
  cvServiceCampaigns_connection?: Maybe<CvServiceCampaignEntityResponseCollection>;
  cvServiceHomeConfig?: Maybe<CvServiceHomeConfig>;
  cvServiceSpecialOfferConfig?: Maybe<CvServiceSpecialOfferConfig>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  lcvColor?: Maybe<LcvColor>;
  lcvColors: Array<Maybe<LcvColor>>;
  lcvColors_connection?: Maybe<LcvColorEntityResponseCollection>;
  lcvContentHubCategories: Array<Maybe<LcvContentHubCategory>>;
  lcvContentHubCategories_connection?: Maybe<LcvContentHubCategoryEntityResponseCollection>;
  lcvContentHubCategory?: Maybe<LcvContentHubCategory>;
  lcvContentHubConfig?: Maybe<LcvContentHubConfig>;
  lcvContentHubContent?: Maybe<LcvContentHubContent>;
  lcvContentHubContents: Array<Maybe<LcvContentHubContent>>;
  lcvContentHubContents_connection?: Maybe<LcvContentHubContentEntityResponseCollection>;
  lcvContentHubTag?: Maybe<LcvContentHubTag>;
  lcvContentHubTags: Array<Maybe<LcvContentHubTag>>;
  lcvContentHubTags_connection?: Maybe<LcvContentHubTagEntityResponseCollection>;
  lcvHomepage?: Maybe<LcvHomepage>;
  lcvInteriorColor?: Maybe<LcvInteriorColor>;
  lcvInteriorColors: Array<Maybe<LcvInteriorColor>>;
  lcvInteriorColors_connection?: Maybe<LcvInteriorColorEntityResponseCollection>;
  lcvMaintenance?: Maybe<LcvMaintenance>;
  lcvMaintenanceConfig?: Maybe<LcvMaintenanceConfig>;
  lcvMaintenances: Array<Maybe<LcvMaintenance>>;
  lcvMaintenances_connection?: Maybe<LcvMaintenanceEntityResponseCollection>;
  lcvModel?: Maybe<LcvModel>;
  lcvModelCategories: Array<Maybe<LcvModelCategory>>;
  lcvModelCategories_connection?: Maybe<LcvModelCategoryEntityResponseCollection>;
  lcvModelCategory?: Maybe<LcvModelCategory>;
  lcvModelColor?: Maybe<LcvModelColor>;
  lcvModelColors: Array<Maybe<LcvModelColor>>;
  lcvModelColors_connection?: Maybe<LcvModelColorEntityResponseCollection>;
  lcvModelConfig?: Maybe<LcvModelConfig>;
  lcvModelSubCategories: Array<Maybe<LcvModelSubCategory>>;
  lcvModelSubCategories_connection?: Maybe<LcvModelSubCategoryEntityResponseCollection>;
  lcvModelSubCategory?: Maybe<LcvModelSubCategory>;
  lcvModels: Array<Maybe<LcvModel>>;
  lcvModels_connection?: Maybe<LcvModelEntityResponseCollection>;
  lcvNewsCategories: Array<Maybe<LcvNewsCategory>>;
  lcvNewsCategories_connection?: Maybe<LcvNewsCategoryEntityResponseCollection>;
  lcvNewsCategory?: Maybe<LcvNewsCategory>;
  lcvNewsConfig?: Maybe<LcvNewsConfig>;
  lcvNewsDetail?: Maybe<LcvNewsDetail>;
  lcvNewsDetails: Array<Maybe<LcvNewsDetail>>;
  lcvNewsDetails_connection?: Maybe<LcvNewsDetailEntityResponseCollection>;
  lcvOffer?: Maybe<LcvOffer>;
  lcvOfferCategories: Array<Maybe<LcvOfferCategory>>;
  lcvOfferCategories_connection?: Maybe<LcvOfferCategoryEntityResponseCollection>;
  lcvOfferCategory?: Maybe<LcvOfferCategory>;
  lcvOfferConfig?: Maybe<LcvOfferConfig>;
  lcvOffers: Array<Maybe<LcvOffer>>;
  lcvOffers_connection?: Maybe<LcvOfferEntityResponseCollection>;
  lcvPartConfig?: Maybe<LcvPartConfig>;
  lcvServiceCampaign?: Maybe<LcvServiceCampaign>;
  lcvServiceCampaignTabDetail?: Maybe<LcvServiceCampaignTabDetail>;
  lcvServiceCampaignTabDetails: Array<Maybe<LcvServiceCampaignTabDetail>>;
  lcvServiceCampaignTabDetails_connection?: Maybe<LcvServiceCampaignTabDetailEntityResponseCollection>;
  lcvServiceCampaigns: Array<Maybe<LcvServiceCampaign>>;
  lcvServiceCampaigns_connection?: Maybe<LcvServiceCampaignEntityResponseCollection>;
  lcvServiceSpecialOfferConfig?: Maybe<LcvServiceSpecialOfferConfig>;
  lcvSpecialCampaign?: Maybe<LcvSpecialCampaign>;
  me?: Maybe<UsersPermissionsMe>;
  omoCvModelConfig?: Maybe<OmoCvModelConfig>;
  omoLcvModelConfig?: Maybe<OmoLcvModelConfig>;
  partCategories: Array<Maybe<PartCategory>>;
  partCategories_connection?: Maybe<PartCategoryEntityResponseCollection>;
  partCategory?: Maybe<PartCategory>;
  partItem?: Maybe<PartItem>;
  partItems: Array<Maybe<PartItem>>;
  partItems_connection?: Maybe<PartItemEntityResponseCollection>;
  questionItem?: Maybe<QuestionItem>;
  questionItems: Array<Maybe<QuestionItem>>;
  questionItems_connection?: Maybe<QuestionItemEntityResponseCollection>;
  referralProgram?: Maybe<ReferralProgram>;
  referralPrograms: Array<Maybe<ReferralProgram>>;
  referralPrograms_connection?: Maybe<ReferralProgramEntityResponseCollection>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  surveyCsiConfig?: Maybe<SurveyCsiConfig>;
  surveySsiConfig?: Maybe<SurveySsiConfig>;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUser>;
  usersPermissionsUsers: Array<Maybe<UsersPermissionsUser>>;
  usersPermissionsUsers_connection?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryCvBodyTypeArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvBodyTypesArgs = {
  filters?: InputMaybe<CvBodyTypeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvBodyTypes_ConnectionArgs = {
  filters?: InputMaybe<CvBodyTypeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvBusinessTypeArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvBusinessTypesArgs = {
  filters?: InputMaybe<CvBusinessTypeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvBusinessTypes_ConnectionArgs = {
  filters?: InputMaybe<CvBusinessTypeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvContentHubCategoriesArgs = {
  filters?: InputMaybe<CvContentHubCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvContentHubCategories_ConnectionArgs = {
  filters?: InputMaybe<CvContentHubCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvContentHubCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvContentHubConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvContentHubContentArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvContentHubContentsArgs = {
  filters?: InputMaybe<CvContentHubContentFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvContentHubContents_ConnectionArgs = {
  filters?: InputMaybe<CvContentHubContentFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvContentHubTagArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvContentHubTagsArgs = {
  filters?: InputMaybe<CvContentHubTagFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvContentHubTags_ConnectionArgs = {
  filters?: InputMaybe<CvContentHubTagFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvHomepageArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvMaintenanceArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvMaintenanceConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvMaintenancesArgs = {
  filters?: InputMaybe<CvMaintenanceFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvMaintenances_ConnectionArgs = {
  filters?: InputMaybe<CvMaintenanceFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelCategoriesArgs = {
  filters?: InputMaybe<CvModelCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelCategories_ConnectionArgs = {
  filters?: InputMaybe<CvModelCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelClassArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelClassesArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelClasses_ConnectionArgs = {
  filters?: InputMaybe<CvModelClassFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelSubCategoriesArgs = {
  filters?: InputMaybe<CvModelSubCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelSubCategories_ConnectionArgs = {
  filters?: InputMaybe<CvModelSubCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelSubCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModelsArgs = {
  filters?: InputMaybe<CvModelFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvModels_ConnectionArgs = {
  filters?: InputMaybe<CvModelFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvOfferArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvOfferCategoriesArgs = {
  filters?: InputMaybe<CvOfferCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvOfferCategories_ConnectionArgs = {
  filters?: InputMaybe<CvOfferCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvOfferCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvOfferConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvOffersArgs = {
  filters?: InputMaybe<CvOfferFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvOffers_ConnectionArgs = {
  filters?: InputMaybe<CvOfferFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvPartConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvSegmentTypeArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvSegmentTypesArgs = {
  filters?: InputMaybe<CvSegmentTypeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvSegmentTypes_ConnectionArgs = {
  filters?: InputMaybe<CvSegmentTypeFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvServiceCampaignArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvServiceCampaignTabDetailArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvServiceCampaignTabDetailsArgs = {
  filters?: InputMaybe<CvServiceCampaignTabDetailFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvServiceCampaignTabDetails_ConnectionArgs = {
  filters?: InputMaybe<CvServiceCampaignTabDetailFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvServiceCampaignsArgs = {
  filters?: InputMaybe<CvServiceCampaignFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvServiceCampaigns_ConnectionArgs = {
  filters?: InputMaybe<CvServiceCampaignFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvServiceHomeConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCvServiceSpecialOfferConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvColorArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvColorsArgs = {
  filters?: InputMaybe<LcvColorFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvColors_ConnectionArgs = {
  filters?: InputMaybe<LcvColorFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvContentHubCategoriesArgs = {
  filters?: InputMaybe<LcvContentHubCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvContentHubCategories_ConnectionArgs = {
  filters?: InputMaybe<LcvContentHubCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvContentHubCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvContentHubConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvContentHubContentArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvContentHubContentsArgs = {
  filters?: InputMaybe<LcvContentHubContentFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvContentHubContents_ConnectionArgs = {
  filters?: InputMaybe<LcvContentHubContentFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvContentHubTagArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvContentHubTagsArgs = {
  filters?: InputMaybe<LcvContentHubTagFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvContentHubTags_ConnectionArgs = {
  filters?: InputMaybe<LcvContentHubTagFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvHomepageArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvInteriorColorArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvInteriorColorsArgs = {
  filters?: InputMaybe<LcvInteriorColorFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvInteriorColors_ConnectionArgs = {
  filters?: InputMaybe<LcvInteriorColorFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvMaintenanceArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvMaintenanceConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvMaintenancesArgs = {
  filters?: InputMaybe<LcvMaintenanceFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvMaintenances_ConnectionArgs = {
  filters?: InputMaybe<LcvMaintenanceFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelCategoriesArgs = {
  filters?: InputMaybe<LcvModelCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelCategories_ConnectionArgs = {
  filters?: InputMaybe<LcvModelCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelColorArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelColorsArgs = {
  filters?: InputMaybe<LcvModelColorFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelColors_ConnectionArgs = {
  filters?: InputMaybe<LcvModelColorFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelSubCategoriesArgs = {
  filters?: InputMaybe<LcvModelSubCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelSubCategories_ConnectionArgs = {
  filters?: InputMaybe<LcvModelSubCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelSubCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModelsArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvModels_ConnectionArgs = {
  filters?: InputMaybe<LcvModelFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvNewsCategoriesArgs = {
  filters?: InputMaybe<LcvNewsCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvNewsCategories_ConnectionArgs = {
  filters?: InputMaybe<LcvNewsCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvNewsCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvNewsConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvNewsDetailArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvNewsDetailsArgs = {
  filters?: InputMaybe<LcvNewsDetailFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvNewsDetails_ConnectionArgs = {
  filters?: InputMaybe<LcvNewsDetailFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvOfferArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvOfferCategoriesArgs = {
  filters?: InputMaybe<LcvOfferCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvOfferCategories_ConnectionArgs = {
  filters?: InputMaybe<LcvOfferCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvOfferCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvOfferConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvOffersArgs = {
  filters?: InputMaybe<LcvOfferFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvOffers_ConnectionArgs = {
  filters?: InputMaybe<LcvOfferFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvPartConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvServiceCampaignArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvServiceCampaignTabDetailArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvServiceCampaignTabDetailsArgs = {
  filters?: InputMaybe<LcvServiceCampaignTabDetailFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvServiceCampaignTabDetails_ConnectionArgs = {
  filters?: InputMaybe<LcvServiceCampaignTabDetailFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvServiceCampaignsArgs = {
  filters?: InputMaybe<LcvServiceCampaignFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvServiceCampaigns_ConnectionArgs = {
  filters?: InputMaybe<LcvServiceCampaignFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvServiceSpecialOfferConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLcvSpecialCampaignArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryOmoCvModelConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryOmoLcvModelConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPartCategoriesArgs = {
  filters?: InputMaybe<PartCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPartCategories_ConnectionArgs = {
  filters?: InputMaybe<PartCategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPartCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPartItemArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPartItemsArgs = {
  filters?: InputMaybe<PartItemFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPartItems_ConnectionArgs = {
  filters?: InputMaybe<PartItemFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryQuestionItemArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryQuestionItemsArgs = {
  filters?: InputMaybe<QuestionItemFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryQuestionItems_ConnectionArgs = {
  filters?: InputMaybe<QuestionItemFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReferralProgramArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReferralProgramsArgs = {
  filters?: InputMaybe<ReferralProgramFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReferralPrograms_ConnectionArgs = {
  filters?: InputMaybe<ReferralProgramFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySurveyCsiConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QuerySurveySsiConfigArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFileArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUserArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};

export type QuestionItem = {
  booleanFalseLabel?: Maybe<ComponentSurveyScaleLabel>;
  booleanTrueLabel?: Maybe<ComponentSurveyScaleLabel>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  maxScaleLabel?: Maybe<ComponentSurveyScaleLabel>;
  minScaleLabel?: Maybe<ComponentSurveyScaleLabel>;
  parentCode?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  questionCode: Scalars['String']['output'];
  questionEn?: Maybe<Scalars['String']['output']>;
  questionTh: Scalars['String']['output'];
  questionType: Enum_Questionitem_Questiontype;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type QuestionItemEntityResponseCollection = {
  nodes: Array<QuestionItem>;
  pageInfo: Pagination;
};

export type QuestionItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<QuestionItemFiltersInput>>>;
  booleanFalseLabel?: InputMaybe<ComponentSurveyScaleLabelFiltersInput>;
  booleanTrueLabel?: InputMaybe<ComponentSurveyScaleLabelFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  maxScaleLabel?: InputMaybe<ComponentSurveyScaleLabelFiltersInput>;
  minScaleLabel?: InputMaybe<ComponentSurveyScaleLabelFiltersInput>;
  not?: InputMaybe<QuestionItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<QuestionItemFiltersInput>>>;
  parentCode?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  questionCode?: InputMaybe<StringFilterInput>;
  questionEn?: InputMaybe<StringFilterInput>;
  questionTh?: InputMaybe<StringFilterInput>;
  questionType?: InputMaybe<StringFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type QuestionItemInput = {
  booleanFalseLabel?: InputMaybe<ComponentSurveyScaleLabelInput>;
  booleanTrueLabel?: InputMaybe<ComponentSurveyScaleLabelInput>;
  locale?: InputMaybe<Scalars['String']['input']>;
  maxScaleLabel?: InputMaybe<ComponentSurveyScaleLabelInput>;
  minScaleLabel?: InputMaybe<ComponentSurveyScaleLabelInput>;
  parentCode?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  questionCode?: InputMaybe<Scalars['String']['input']>;
  questionEn?: InputMaybe<Scalars['String']['input']>;
  questionTh?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<Enum_Questionitem_Questiontype>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionItemRelationResponseCollection = {
  nodes: Array<QuestionItem>;
};

export type ReferralProgram = {
  campaignCode: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  documentId: Scalars['ID']['output'];
  image: UploadFile;
  metatagDescription?: Maybe<Scalars['String']['output']>;
  metatagTitle?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReferralProgramEntityResponseCollection = {
  nodes: Array<ReferralProgram>;
  pageInfo: Pagination;
};

export type ReferralProgramFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReferralProgramFiltersInput>>>;
  campaignCode?: InputMaybe<StringFilterInput>;
  campaignName?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  metatagDescription?: InputMaybe<StringFilterInput>;
  metatagTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReferralProgramFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReferralProgramFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReferralProgramInput = {
  campaignCode?: InputMaybe<Scalars['String']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metatagDescription?: InputMaybe<Scalars['String']['input']>;
  metatagTitle?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReviewWorkflowsWorkflow = {
  contentTypes: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stageRequiredToPublish?: InputMaybe<Scalars['ID']['input']>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workflow?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyCsiConfig = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versions?: Maybe<Array<Maybe<ComponentSurveySurveyVersion>>>;
};


export type SurveyCsiConfigVersionsArgs = {
  filters?: InputMaybe<ComponentSurveySurveyVersionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SurveyCsiConfigInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  versions?: InputMaybe<Array<InputMaybe<ComponentSurveySurveyVersionInput>>>;
};

export type SurveySsiConfig = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versions?: Maybe<Array<Maybe<ComponentSurveySurveyVersion>>>;
};


export type SurveySsiConfigVersionsArgs = {
  filters?: InputMaybe<ComponentSurveySurveyVersionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SurveySsiConfigInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  versions?: InputMaybe<Array<InputMaybe<ComponentSurveySurveyVersionInput>>>;
};

export type UploadFile = {
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  focalPoint?: Maybe<Scalars['JSON']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntityResponseCollection = {
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  focalPoint?: InputMaybe<JsonFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileRelationResponseCollection = {
  nodes: Array<UploadFile>;
};

export type UsersPermissionsCreateRolePayload = {
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<UsersPermissionsUser>>;
  users_connection?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  strapi_stage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntityResponse = {
  data?: Maybe<UsersPermissionsUser>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  nodes: Array<UsersPermissionsUser>;
  pageInfo: Pagination;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  strapi_stage?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  strapi_stage?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  nodes: Array<UsersPermissionsUser>;
};
